{
  "cta": {
    "create-a-chart": "Vytvořit tabulku"
  },
  "breadcrumb": {
    "dashboard": "Přehled",
    "products": "Produkty",
    "charts": "Tabulky",
    "restock-alerts": "Upozornění na doplnění skladu",
    "settings": "Nastavení",
    "setting": "Nastavení",
    "account": "Účet",
    "personal": "Osobní",
    "organization": "Organizace",
    "appearance": "Vzhled",
    "themes": "Motivy",
    "button": "Tlačítko",
    "font-family": "Rodina písma",
    "uploads": "Nahrané soubory",
    "dimensions": "Rozměry",
    "notifications": "Oznámení",
    "analytic": "Analytika",
    "analytics": "Analytika",
    "restock-settings": "Nastavení doplnění skladu",
    "inventory": "Upozornění na doplnění skladu",
    "plans": "Plány",
    "billing": "Fakturace",
    "overview": "Přehled",
    "plan-and-usage": "Plán a využití",
    "chart-views": "Zobrazení tabulky",
    "add-to-cart": "Přidat do košíku",
    "buy-now": "Koupit nyní",
    "size-recommendations": "Doporučení velikosti",
    "stock-notifications": "Oznámení o skladu",
    "reports": "Reporty",
    "comparison": "Porovnání",
    "images": "Nahrané soubory",
    "sidekick": "Sidekick",
    "import": "Import",
    "contact": "Kontakt",
    "help-articles": "Články nápovědy",
    "new": "Nový"
  },
  "page": {
    "dashboard": {
      "table-style-chart": "Tabulka ve stylu mřížky",
      "build-a-fully-custom-grid-with-complete-control-over-every-row-column-and-measurement-unit-best-for-complex-sizing-across-multiple-regions": "Vytvořte zcela vlastní mřížku s úplnou kontrolou nad každým řádkem, sloupcem a měrnou jednotkou. Ideální pro komplexní velikosti napříč více regiony.",
      "create-table-chart": "Vytvořit tabulku mřížky",
      "create-from-product": "Vytvořit z produktu",
      "start-from-template": "Začít od šablony",
      "browse-templates": "Procházet šablony",
      "create-with-drag-drop": "Vytvořit přetažením",
      "creating": "Vytváření",
      "how-would-you-like-to-build-your-chart": "Jak byste chtěli<br /><span class=\"text-primary\">vytvořit svou tabulku velikostí?</span>",
      "choose-a-method-below-or-tell-us-what-you-sell-and-we-ll-highlight-the-best-fit": "Vyberte metodu níže, nebo nám řekněte, co prodáváte, a doporučíme tu nejvhodnější.",
      "fastest-setup-2-min": "Nejrychlejší nastavení · ~2 min",
      "used-by-1000-merchants": "Používá více než 1000 obchodníků",
      "auto-generate-a-matching-size-chart-directly-from-your-existing-shopify-variant-data-no-manual-entry-it-reads-your-product-and-fills-the-table-for-you": "Automaticky vygenerujte odpovídající tabulku velikostí přímo z existujících dat variant Shopify. Žádné ruční zadávání – přečte váš produkt a vyplní tabulku za vás",
      "garment-templates-ready-to-use": "Šablony oděvů připravené k použití",
      "pick-from-ready-made-templates-for-tops-bottoms-shoes-belts-bags-and-more-customise-any-field-after-great-for-getting-started-in-under-a-minute": "Vyberte si z předpřipravených šablon pro horní díly, spodní díly, obuv, opasky, tašky a další. Kterékoli pole pak můžete upravit – skvělé pro rychlý start za méně než minutu.",
      "drag-drop-no-data-needed-upfront": "Přetažení · žádná data předem nejsou potřeba",
      "upload-any-product-image-and-annotate-measurements-directly-on-it-with-drag-drop-pins-ideal-for-shoes-bags-accessories-and-equipment": "Nahrajte libovolný obrázek produktu a přímo na něj vyznačte míry pomocí přetahovaných bodů. Ideální pro obuv, tašky, doplňky a vybavení.",
      "excel-like": "Podobné Excelu",
      "auto-generated": "Automaticky vygenerováno",
      "annotate-on-image": "Anotovat na obrázku",
      "what-are-you-selling": "Co prodáváte?",
      "category-clothing-apparel": "Oblečení a oděvy",
      "category-shoes": "Obuv",
      "category-accessories": "Doplňky",
      "category-other": "Něco jiného",
      "start-date": "Datum zahájení",
      "end-date": "Datum ukončení"
    },
    "products": {
      "select-a-product-to-create-or-link-a-size-chart-for-that-product": "Vyberte produkt a vytvořte nebo propojte tabulku velikostí pro tento produkt.",
      "product-name": "Název produktu",
      "best-selling": "Nejprodávanější",
      "most-selling": "Nejprodávanější nejdříve",
      "least-selling": "Nejméně prodávané",
      "best-selling-unavailable": "Údaje o prodejích zatím nejsou k dispozici, proto jsou produkty seřazeny podle poslední aktualizace.",
      "chart-attached": "Přiložená tabulka",
      "shopify-status": "Stav Shopify",
      "search-placeholder": "Hledat ve všech produktech...",
      "vendors": "Dodavatelé",
      "tags": "Štítky",
      "statuses": "Stavy",
      "collections": "Kolekce",
      "types": "Typy",
      "add-filter": "Přidat filtr",
      "categories": "Kategorie",
      "search-and-filter-tooltip": "Hledat a filtrovat (F)",
      "import-selection": "Importovat výběr",
      "failed-import-measurements": "Import měr se nezdařil",
      "product-updated": "Produkt byl úspěšně aktualizován"
    },
    "charts": {
      "create-edit-duplicate-or-link-a-chart-to-a-product-from-here": "Zde můžete vytvářet, upravovat, duplikovat nebo propojovat tabulky s produkty.",
      "chart-name": "Název tabulky",
      "chart-type": "Typ tabulky",
      "linked-to": "Propojeno s",
      "last-updated": "Naposledy aktualizováno",
      "delete-x-charts": "Odstranit {{ x }} tabulek",
      "assigned-products": "Přiřazené produkty",
      "failed-to-fetch-products-data": "Nepodařilo se načíst data produktů",
      "delete-chart": "Odstranit tabulku",
      "are-you-sure-you-want-to-delete-selected-chart-s-all-products-using-chart-s-will-be-unassigned": "Opravdu chcete odstranit vybranou tabulku (tabulky)? Všechny produkty používající tuto tabulku (tabulky) budou odpojeny.",
      "successfully-deleted-chart-s": "Tabulka (tabulky) byla úspěšně odstraněna!",
      "successfully-duplicated-chart": "Tabulka byla úspěšně duplikována!",
      "turn-this-into-a-conversion-chart": "Přeměnit na konverzní tabulku",
      "upgradable-tooltip": "Tato tabulka mřížky vypadá jako strukturovaná tabulka velikostí a lze ji převést.",
      "convert-to-size-chart": "Převést na tabulku velikostí",
      "convertibility-failed": "Nepodařilo se ověřit, které tabulky mřížky lze převést.",
      "convert": {
        "table-chart-info-callout": "Tuto tabulku mřížky lze převést na chytrou tabulku velikostí",
        "table-chart-info-callout-message": "Převodem se vaše mřížka namapuje na rozměry z vaší knihovny, čímž se odemkne vizuální průvodce měřením a informace o modelu, které obyčejná tabulka nedokáže zobrazit.",
        "successfully-converted": "Úspěšně převedeno na tabulku velikostí!",
        "detected-sizes": "Zjištěné velikosti",
        "at-least-two-sizes-are-needed": "K převodu této tabulky jsou potřeba alespoň dvě velikosti.",
        "unnamed-row": "Nepojmenovaný řádek",
        "ignore-this-row": "Ignorovat tento řádek",
        "this-dimension-is-already-mapped": "Tento rozměr je již namapován na jiný řádek.",
        "map-at-least-one-row": "Namapujte alespoň jeden řádek na rozměr.",
        "finish-your-measurement-guide": "Dokončete průvodce měřením",
        "measurement-points-without-values": "Body měření bez hodnot ({{ x }})",
        "fill-them-in-after-converting": "Váš vybraný obrázek je zobrazuje, ale vaše tabulka takové řádky neobsahovala. Vyplňte jejich hodnoty po převodu.",
        "measurements-without-points": "Míry bez bodu na vašem obrázku ({{ x }})",
        "no-image-selected-yet": "Zatím není vybrán žádný obrázek",
        "upload-an-image-then-drag-points": "Nahrajte obrázek a poté na něj přetáhněte body měření.",
        "your-image-has-no-measurement-points": "Váš vybraný obrázek zatím nemá žádné body měření",
        "drag-measurement-points-onto-the-image": "Přetáhněte body měření na obrázek, aby zákazníci viděli, kde měřit.",
        "plus-x-more": "+{{ x }} další",
        "satisfied-button": "Vypadá dobře — nastavit jako mou aktivní tabulku",
        "satisfied-explanation": "Vaše tabulka mřížky bude zveřejnění zrušeno, tato tabulka bude zveřejněna a její přiřazené produkty se přesunou.",
        "satisfied-success": "Tato tabulka je nyní aktivní!",
        "step-x-of-y": "Krok {{ x }} z {{ y }}",
        "choose-product-type": "Vyberte typ produktu",
        "well-match-your-table-to-a-visual": "Vaši tabulku spárujeme se správným vizuálním produktem.",
        "save-settings": "Uložit nastavení",
        "review-table-mapping": "Zkontrolovat mapování tabulky",
        "confirm-the-rows-to-convert": "Potvrďte řádky, které máme převést.",
        "existing-table": "Existující tabulka",
        "sizes": "Velikosti",
        "row": "Řádek",
        "column": "Sloupec",
        "x-rows-need-review": "{{ x }} řádků vyžaduje kontrolu",
        "couldnt-match-this-row": "Tuto míru se nepodařilo automaticky spárovat",
        "change-match": "Změnit shodu",
        "view-values": "Zobrazit hodnoty",
        "hide-values": "Skrýt hodnoty",
        "matched-automatically": "Spárováno automaticky",
        "edit-matches": "Upravit shody",
        "create-preview": "Vytvořit náhled",
        "preview-ready": "Náhled připraven",
        "open-it-to-finish-the-missing-values": "Otevřete jej a doplňte chybějící hodnoty.",
        "converted": "Převedeno",
        "open-preview": "Otevřít náhled",
        "you-can-add-them-in-the-preview": "Můžete je přidat v náhledu."
      }
    },
    "inventory": {
      "collect-emails-and-send-automatic-back-in-stock-notifications-setup-notification": "Sbírejte e-maily a odesílejte automatická oznámení o doplnění skladu. Nastavit oznámení",
      "here": "zde",
      "successfully-export-inventory-data": "Data skladu byla úspěšně exportována",
      "active-your-store-inventory-notification-feature": "Aktivujte funkci oznámení o skladu vašeho obchodu",
      "in-order-to-receive-users-subscribed-for-your-products": "abyste dostávali uživatele přihlášené k odběru vašich produktů.",
      "your-subscribers-have-been-delegeted-to-your": "Vaši odběratelé byli přesunuti do vašeho"
    },
    "setting": {
      "storefront-popup-preview": "Náhled vyskakovacího okna obchodu",
      "add-to-cart": "Přidat do košíku",
      "buy-now": "Koupit nyní",
      "sans-serif": "Bezpatkové",
      "serif": "Patkové",
      "email-body-is-required": "Tělo e-mailu je povinné",
      "list": "Seznam",
      "category-image": "Obrázek kategorie",
      "pay-over-usage-cost": "Zaplatit náklady za nadměrné využití",
      "over-usage-count": "Počet nadměrného využití",
      "over-usage-cost": "Náklady za nadměrné využití",
      "x-usages": "{{ x }} použití",
      "failed-to-pay-over-usage-cost": "Nepodařilo se zaplatit náklady za nadměrné využití",
      "manage-your-personal-information-and-account-perferences": "Spravujte své osobní údaje a předvolby účtu.",
      "manage-your-organization-contact-information-and-address": "Spravujte kontaktní údaje a adresu vaší organizace.",
      "manage-your-billing-overview": "Zkontrolujte podrobnosti o fakturaci, plánu a platebních údajích.",
      "manage-your-plan-and-usage": "Zobrazte svůj aktuální plán a limity využití.",
      "manage-your-measurement-dimensions": "Spravujte rozměry měření používané ve vašich tabulkách velikostí.",
      "dimension-translations": "Překlady pro obchod",
      "dimension-translations-description": "Zadejte popisek, který mají zákazníci vidět pro každý podporovaný jazyk obchodu. Ponechte prázdné pro použití výchozího názvu.",
      "default-dimension-name": "Výchozí název rozměru",
      "dimension-name-description": "Používá se v celém panelu a jako záložní hodnota pro obchod, pokud není poskytnut žádný překlad.",
      "storefront-label": "Popisek pro obchod",
      "naming": "Pojmenování",
      "affecting-data": "Ovlivněná data",
      "first-name-is-required": "Jméno je povinné",
      "last-name-is-required": "Příjmení je povinné",
      "subscribed-for-our-latest-news-exclusive-offers-and-exciting-updates": "Přihlášeno k odběru našich nejnovějších zpráv, exkluzivních nabídek a zajímavých novinek.",
      "contact-information": "Kontaktní údaje",
      "contact-name": "Jméno kontaktu",
      "contact-name-is-required": "Jméno kontaktu je povinné!",
      "contact-email": "Kontaktní e-mail",
      "contact-email-is-required": "Kontaktní e-mail je povinný!",
      "contact-email-is-invalid": "Kontaktní e-mail není platný!",
      "company-organization-name": "Název firmy/organizace",
      "company-organization-name-is-required": "Název firmy/organizace je povinný",
      "street-address": "Ulice",
      "street-address-is-required": "Ulice je povinná!",
      "street-address-2": "Ulice 2",
      "city": "Město",
      "city-is-required": "Město je povinné!",
      "state-province-region": "Stát/provincie/oblast",
      "state-province-region-is-required": "Stát/provincie/oblast je povinné!",
      "country": "Země",
      "country-is-required": "Země je povinná!",
      "postal-zip-code": "PSČ",
      "postal-zip-code-is-required": "PSČ je povinné!",
      "themes": "Motivy",
      "customise-your-app-look-choose-a-colour-that-best-represents-your-brand": "Přizpůsobte si vzhled aplikace! Zvolte barvu, která nejlépe reprezentuje vaši značku",
      "sunset-ember": "Žhavý západ",
      "classic-noir": "Klasická černá",
      "system-background-colour": "Barva systémového pozadí",
      "customise-your-button": "Přizpůsobit tlačítko",
      "customise-your-button-text-colour-and-style-to-match-your-brand": "Přizpůsobte text, barvu a styl tlačítka podle vaší značky.",
      "what-should-the-button-say": "Co má tlačítko říkat?",
      "label-button-is-required": "Popisek tlačítka je povinný!",
      "text-colour": "Barva textu",
      "text-colour-is-required": "Barva textu je povinná!",
      "please-input-valid-hex-color-code": "Zadejte platný hexadecimální kód barvy",
      "background-color": "Barva pozadí",
      "background-colour-is-required": "Barva pozadí je povinná!",
      "font-size-in-px": "Velikost písma v px",
      "font-size-in-px-is-required": "Velikost písma v px je povinná!",
      "border-radius": "Poloměr okraje",
      "border-radius-is-required": "Poloměr okraje je povinný!",
      "successfully-updated-button-style": "Styl tlačítka byl úspěšně aktualizován",
      "font-family": "Rodina písma",
      "customise-your-font": "Přizpůsobit písmo",
      "match-your-store-look-and-feel-by-updating-the-font-across-your-size-charts": "Sjednoťte vzhled svého obchodu aktualizací písma napříč tabulkami velikostí.",
      "select-a-font-from-the-list-bellow": "Vyberte písmo ze seznamu níže.",
      "search-font": "Hledat písmo...",
      "fetching-fonts": "Načítání písem...",
      "showing-x-fonts": "Zobrazeno {{ x }} písem",
      "sort-by-x": "Seřadit podle {{ x }}",
      "most-popular": "Nejoblíbenější",
      "here-how-it-will-look-on-your-shop": "Takto to bude vypadat ve vašem obchodě",
      "it-ll-updated-across-all-your-chart-displays": "Aktualizuje se napříč všemi zobrazeními tabulek.",
      "update-font-across-all-size-charts": "Aktualizovat písmo ve všech tabulkách velikostí",
      "choose-a-font-to-match-your-store-style": "Zvolte písmo odpovídající stylu vašeho obchodu",
      "apply-font": "Použít písmo",
      "font-applied-successfully": "Písmo bylo úspěšně použito!",
      "manage-and-delete-your-uploaded-images-removing-a-file-is-permanent-and-cannot-be-undone": "Spravujte a odstraňujte nahrané obrázky. Odstranění souboru je trvalé a nelze jej vrátit zpět.",
      "do-you-want-to-delete-image": "Chcete odstranit obrázek?",
      "image-deleted-successfully": "Obrázek byl úspěšně odstraněn",
      "chart-list": "Seznam tabulek",
      "delete-x-dimensions": "Odstranit {{ x }} rozměrů",
      "view-affecting-data": "Zobrazit ovlivněná data",
      "no-data-will-be-affected": "Žádná data nebudou ovlivněna.",
      "do-you-want-to-delete-selected-dimensions": "Chcete odstranit vybrané rozměry?",
      "any-annotation-sets-and-charts-currently-using-these-dimensions-will-have-its-annotation-and-data-removed": "Všem sadám anotací a tabulkám, které tyto rozměry aktuálně používají, budou odstraněny jejich anotace a data",
      "any-annotation-sets-and-charts-currently-using-these-dimensions-will-have-its-name-changed": "Všem sadám anotací a tabulkám, které tyto rozměry aktuálně používají, bude změněn název",
      "delete-dimension": "Odstranit rozměr",
      "successfully-deleted-dimension": "Rozměr(y) byl(y) úspěšně odstraněn(y)!",
      "successfully-update-dimension": "Rozměr byl úspěšně aktualizován!",
      "configure-how-back-in-stock-notifications-work-for-your-customers": "Nastavte, jak fungují oznámení o doplnění skladu pro vaše zákazníky",
      "activate-back-in-stock-notifications": "Aktivovat oznámení o doplnění skladu",
      "allow-shoppers-to-subscribe-for-alerts-when-a-size-or-product-is-sold-out-notifications-will-be-sent-automatically-once-stock-is-available": "Umožněte zákazníkům přihlásit se k upozorněním, když je velikost nebo produkt vyprodán. Oznámení budou odeslána automaticky, jakmile bude zboží opět skladem.",
      "notification-channels": "Kanály oznámení",
      "third-party-service": "Služba třetí strany",
      "sms": "SMS",
      "coming-soon": "Již brzy",
      "signup-experience-design": "Design zážitku při registraci",
      "form-display": "Zobrazení formuláře",
      "modal-popup": "Modální vyskakovací okno",
      "email-template-customisation": "Přizpůsobení šablony e-mailu",
      "subject-line": "Předmět",
      "subject-line-is-required": "Předmět je povinný",
      "your-size-is-back-in-stock": "Vaše velikost je opět skladem 🎉",
      "email-body": "Tělo e-mailu",
      "inventory-threshold-setting": "Nastavení prahu skladu",
      "notify-shoppers-when-inventory-reaches-at-least": "Upozornit zákazníky, když sklad dosáhne alespoň",
      "threshold-is-required": "Práh je povinný",
      "threshold-must-be-greater-than-0": "Práh musí být větší než 0",
      "units": "kusů",
      "set-the-minimum-inventory-level-required-to-trigger-notifications": "Nastavte minimální úroveň skladu potřebnou ke spuštění oznámení",
      "choose-a-service": "Vyberte službu",
      "signing-out": "Odhlašování",
      "signout-of": "Odhlásit z",
      "authenticate": "Ověřit",
      "save-settings": "Uložit nastavení",
      "hi-your-is-now-back-in-stock-get-it-before-it-gone": "Ahoj {{first_name}}, tvůj/tvá {{product_name}} ({{size_variant}}) je nyní opět skladem. Nakup dřív, než zase dojde!",
      "successfully-updated-notification-back-in-stock": "Oznámení o doplnění skladu bylo úspěšně aktualizováno",
      "preferred-language": "Preferovaný jazyk",
      "successfully-updated-your-profile": "Váš profil byl úspěšně aktualizován",
      "successfully-updated-mailing-subscription-status": "Stav odběru novinek byl úspěšně aktualizován!",
      "upgrade-plan": "Upgradovat plán",
      "overview": "Přehled",
      "billing-cycle": "Fakturační cyklus",
      "billing-cycle-resets-at-midnight-on-x-and-the-next-charge-is-on-y": "Fakturační cyklus se resetuje o půlnoci {{ x }} a další platba proběhne {{ y }}",
      "billing-information": "Fakturační údaje",
      "update-billing": "Aktualizovat fakturaci",
      "monthly-total": "Měsíční celkem",
      "free-trial-x-days-left": "Bezplatná zkušební verze – zbývá {{ x }} dní",
      "cancel-plan": "Zrušit plán",
      "change-plan": "Změnit plán",
      "plan-and-usage": "Plán a využití",
      "tier-offers-in-use": "Používané nabídky úrovně",
      "failed-to-cancel-plan": "Zrušení plánu se nezdařilo",
      "total-usage": "Celkové využití",
      "current-usage-summary": "Přehled aktuálního využití",
      "published-charts": "Zveřejněné tabulky",
      "limit-reached": "limit dosažen",
      "plan-details": "Podrobnosti plánu",
      "current-plan": "Aktuální plán",
      "select-a-reason": "Vyberte důvod",
      "please-provide-your-reason": "Uveďte svůj důvod",
      "chart-preferences": "Předvolby tabulky",
      "skip-picking-dimensions-when-creating-a-new-chart-from-template": "Přeskočit výběr rozměrů při vytváření nové tabulky ze šablony",
      "border-color": "Barva okraje",
      "border-color-is-required": "Barva okraje je povinná!",
      "list-of-charts-using-this-image": "Seznam tabulek používajících tento obrázek",
      "successfully-update-your-profile": "Váš profil byl úspěšně aktualizován"
    },
    "analytic": {
      "failed-to-load-statistics": "Nepodařilo se načíst statistiky",
      "total-chart-views": "Zobrazení tabulky",
      "total-add-to-cart": "Přidání do košíku",
      "traffic-by-location": "Návštěvnost podle lokality",
      "desktop": "Počítač",
      "mobile": "Mobil",
      "size-recommendations": {
        "failed-to-load": "Nepodařilo se načíst analytiku doporučení velikosti",
        "total-suggestions-title": "Učiněná doporučení",
        "conversion-title": "Konverze",
        "customers-proceeded": "Zákazníci pokračovali s doporučením",
        "of-x-suggestions": "z {{count}} doporučení",
        "most-suggested-title": "Nejčastěji doporučený produkt a varianta",
        "suggestions-count": "{{count}} doporučení",
        "most-common-profile-title": "Nejběžnější profil",
        "average-profile-title": "Průměrný profil",
        "gender": "Pohlaví",
        "age-group": "Věková skupina",
        "height": "Výška",
        "weight": "Hmotnost",
        "size-recommended": "Doporučená velikost",
        "graph-suggestions": "Doporučení",
        "graph-proceed": "Pokračovat",
        "source-all": "Vše",
        "source-chart": "Tabulka velikostí",
        "source-table-chart": "Tabulka mřížky"
      },
      "chart-views": {
        "failed-to-load": "Nepodařilo se načíst zobrazení tabulky",
        "device-types": "Typy zařízení",
        "most-viewed-chart": "Nejsledovanější tabulka",
        "most-viewed-product": "Nejsledovanější produkt",
        "views-count": "{{ count }} zobrazení",
        "view-at": "Zobrazeno v",
        "location": "Lokalita",
        "graph-label": "Zobrazení"
      },
      "add-to-cart": {
        "failed-to-load": "Nepodařilo se načíst analytiku přidání do košíku",
        "estimated-revenue": "Odhadovaná ovlivněná hodnota",
        "conversion-title": "Konverze zobrazení tabulky → přidání do košíku",
        "most": "Nejčastěji přidáno do košíku",
        "adds-count": "{{count}} přidání do košíku",
        "added-at": "Přidáno v",
        "graph-label": "Přidání do košíku",
        "views-dataset-label": "Zobrazení",
        "add-to-cart-dataset-label": "Přidat do košíku"
      },
      "stock-notifications": {
        "failed-to-load": "Nepodařilo se načíst analytiku oznámení o skladu",
        "failed-to-load-table": "Nepodařilo se načíst tabulku oznámení o skladu",
        "total-subscriptions": "Odběry",
        "total-notifications-sent": "Odeslaná oznámení",
        "delivery-rate": "Míra doručení",
        "opened-of-notified": "{{ opened }} otevřeno / {{ notified }} upozorněno",
        "most-subscribed": "Nejvíce odebíráno",
        "subscriptions-count": "{{ count }} odběrů",
        "latest-subscribed": "Poslední odběr",
        "subscribed-at": "Odebráno: {{ date }}",
        "longest-waiting": "Nejdéle čeká na doplnění skladu",
        "waiting-days": "Čeká: {{ days }} dní",
        "waiting-since": "(od {{ date }})",
        "subscriptions": "Odběry",
        "notifications-sent": "Odeslaná oznámení",
        "opened": "Otevřeno",
        "at": "V",
        "graph-label": "Odběry"
      },
      "paid-gate": {
        "unlock-message": "Odemkněte pokročilou analytiku a zobrazte si úplná data pro lepší rozhodování.",
        "upgrade": "Upgradovat",
        "failed-to-fetch-plans": "Nepodařilo se načíst plány"
      },
      "buy-now": {
        "failed-to-load": "Nepodařilo se načíst analytiku koupě nyní",
        "total": "Koupě nyní",
        "estimated-revenue": "Odhadovaná ovlivněná hodnota",
        "conversion-title": "Konverze zobrazení tabulky → koupě nyní",
        "most": "Nejčastěji kupovaný produkt přes Koupit nyní",
        "buys-count": "{{count}} koupí nyní",
        "graph-label": "Koupě nyní",
        "views-dataset-label": "Zobrazení",
        "buy-now-dataset-label": "Koupit nyní",
        "clicked-at": "Kliknuto v"
      },
      "overview": {
        "funnel-title": "Kam vedla zobrazení tabulky velikostí",
        "no-views-title": "V tomto období žádná zobrazení tabulky",
        "no-views-hint": "Tabulky velikostí se na stránkách produktů zobrazí, jakmile je publikujete a přiřadíte k produktům.",
        "chart-views-caption": "Zákazníci, kteří otevřeli tabulku velikostí",
        "baseline-caption": "Vše níže se poměřuje s těmito zobrazeními",
        "of-views": "z {{ count }} zobrazení",
        "not-in-funnel": "Mimo cestu k nákupu přes tabulku"
      },
      "preview": {
        "title": "Zatím žádná data — toto je ukázka",
        "message": "Níže uvedené údaje jsou ukázkové a ukazují, jak bude tato stránka vypadat, až zákazníci začnou používat vaše tabulky velikostí."
      }
    },
    "plans": {
      "popular-plan": "Oblíbený plán",
      "try-now": "Vyzkoušet nyní",
      "activated": "Aktivováno",
      "contact-sales": "Kontaktovat obchod",
      "try-free-for-1-month": "Vyzkoušet zdarma na 1 měsíc",
      "activate": "Aktivovat",
      "what-included": "Co je zahrnuto?",
      "choose-the-plan-that-fits-your-business-needs": "Vyberte plán, který vyhovuje potřebám vašeho podnikání",
      "whether-youre-just-starting-out-or-looking-for-a-robust-sizing-solution-weve-got-a-plan-thats-right-for-you": "Ať už teprve začínáte, nebo hledáte robustní řešení pro velikosti, máme pro vás vhodný plán.",
      "monthly": "Měsíčně",
      "annually": "Ročně",
      "compare-plan-features": "Porovnat funkce plánů",
      "compare-all-plan-features": "Porovnat všechny funkce plánů",
      "feature-usages": "Využití",
      "feature-analytics": "Analytika",
      "feature-support": "Podpora",
      "feature-integration": "Integrace",
      "feature-branding": "Branding",
      "feature-api-access": "Přístup k API",
      "feature-stock-notifications": "Oznámení o skladu",
      "feature-published-conversion-charts": "Zveřejněné konverzní tabulky",
      "feature-advanced-variant-mapping": "Pokročilé mapování variant",
      "failed-to-fetch-plans": "Nepodařilo se načíst plány",
      "failed-to-activate-plan": "Aktivace plánu se nezdařila",
      "contact": {
        "title": "Kontaktovat obchod",
        "subtitle": "Řekněte nám o svém obchodě a o tom, co potřebujete. Náš tým se vám ozve e-mailem.",
        "message-placeholder": "Jak můžeme pomoci vašemu podnikání?",
        "send": "Odeslat zprávu",
        "success": "Děkujeme! Vaše zpráva byla odeslána. Náš tým se vám brzy ozve.",
        "first-name-required": "Jméno je povinné",
        "last-name-required": "Příjmení je povinné",
        "email-required": "E-mail je povinný",
        "email-invalid": "E-mail není platný",
        "message-required": "Zpráva je povinná"
      },
      "invite": {
        "title": "Dokončete předplatné",
        "your-plan": "Váš tarif",
        "order-summary": "Souhrn objednávky",
        "billed-every-30-days": "Účtováno každých 30 dní",
        "billed-yearly": "Účtováno ročně",
        "free-trial": "Zkušební verze zdarma: {{days}} dní",
        "due-today": "K úhradě dnes",
        "then-every-30-days": "Poté {{price}} USD každých 30 dní",
        "then-yearly": "Poté {{price}} USD ročně",
        "continue": "Pokračovat ke schválení",
        "shopify-note": "Účtováno přes Shopify. Platbu schválíte na další obrazovce.",
        "switching-note": "Po schválení nahradí váš současný tarif. Shopify započítá kredit za zbývající dobu.",
        "already-on-plan": "Tento tarif už máte",
        "unavailable-title": "Tato pozvánka už není k dispozici",
        "unavailable-body": "Platnost odkazu možná vypršela. Kontaktujte osobu, která ho poslala, nebo si prohlédněte tarify dostupné všem obchodům.",
        "see-plans": "Zobrazit tarify",
        "failed-title": "Tento tarif se nepodařilo načíst",
        "failed-body": "Zkontrolujte připojení a znovu načtěte stránku."
      }
    },
    "auth": {
      "signin": {
        "please-sign-in": "Přihlaste se prosím",
        "email-is-required": "E-mail je povinný",
        "invalid-email-address": "Neplatná e-mailová adresa",
        "password-is-required": "Heslo je povinné",
        "sign-in": "Přihlásit se",
        "reset-password": "Obnovit heslo",
        "generic-error": "Během procesu došlo k chybě! Zkuste to prosím později znovu."
      }
    },
    "admin": {
      "reports": {
        "title": "Reporty",
        "chart-views": {
          "title": "Zobrazení tabulky",
          "description": "Zjistěte, kolikrát zákazníci otevřeli tabulku velikostí, globálně napříč všemi obchody.",
          "failed-to-load": "Nepodařilo se načíst report zobrazení tabulky",
          "total-views": "Zobrazení tabulky",
          "most-viewed-chart": "Nejsledovanější tabulka",
          "most-viewed-product": "Nejsledovanější produkt",
          "views-count": "{{ count }} zobrazení",
          "traffic-by-location": "Návštěvnost podle lokality",
          "device-types": "Typy zařízení",
          "desktop": "Počítač",
          "mobile": "Mobil",
          "top-stores": "Nejlepší obchody",
          "no-top-stores": "Zatím žádná data o obchodech",
          "graph-label": "Zobrazení",
          "view-at": "Zobrazeno v",
          "location": "Lokalita"
        },
        "add-to-cart": {
          "title": "Přidat do košíku",
          "description": "Zjistěte, jak tabulka velikostí ovlivňuje přidání do košíku, globálně napříč všemi obchody.",
          "failed-to-load": "Nepodařilo se načíst report přidání do košíku",
          "total-add-to-cart": "Přidání do košíku",
          "conversion-title": "Konverze zobrazení tabulky → přidání do košíku",
          "most": "Nejčastěji přidáno do košíku",
          "adds-count": "{{ count }} přidání do košíku",
          "top-stores": "Nejlepší obchody",
          "no-top-stores": "Zatím žádná data o obchodech",
          "graph-label": "Přidání do košíku",
          "views-dataset-label": "Zobrazení",
          "add-to-cart-dataset-label": "Přidat do košíku",
          "added-at": "Přidáno v"
        },
        "buy-now": {
          "title": "Koupit nyní",
          "description": "Zjistěte, jak tabulka velikostí ovlivňuje koupě nyní, globálně napříč všemi obchody.",
          "failed-to-load": "Nepodařilo se načíst report koupě nyní",
          "total-buy-now": "Koupě nyní",
          "conversion-title": "Konverze zobrazení tabulky → koupě nyní",
          "most": "Nejčastěji kupovaný produkt přes Koupit nyní",
          "buys-count": "{{ count }} koupí nyní",
          "top-stores": "Nejlepší obchody",
          "no-top-stores": "Zatím žádná data o obchodech",
          "graph-label": "Koupě nyní",
          "views-dataset-label": "Zobrazení",
          "buy-now-dataset-label": "Koupit nyní",
          "clicked-at": "Kliknuto v"
        },
        "conversion-funnel": {
          "title": "Konverze tabulky mřížky",
          "description": "Zjistěte, kde obchodníci přerušují převod tabulky mřížky na tabulku velikostí, globálně napříč všemi obchody.",
          "failed-to-load": "Nepodařilo se načíst report konverze tabulky mřížky",
          "total-runs": "Zahájené konverze",
          "runs-breakdown": "{{ converted }} převedeno · {{ handedOver }} předáno",
          "conversion-title": "Zahájeno → Převedeno",
          "handover-rate": "{{ rate }} % pokračovalo a předalo své produkty",
          "handover-gap-title": "Převedeno, ale nepředáno",
          "of-converted-runs": "z převedených pokusů",
          "handover-gap-description": "K předání může dojít i o několik dní později, takže některé z nich jsou spíše čekající než opuštěné.",
          "funnel-title": "Konverzní trychtýř",
          "funnel-note": "Vyhrazený krok předání se již nespouští – k dokončení předání dochází nyní prostřednictvím banneru, takže jeho počet čtěte jako celkový počet předání, nikoli jako konverzi kroku.",
          "no-funnel": "V tomto rozsahu nejsou žádné pokusy o konverzi",
          "drop-off": "opuštění",
          "runs-dataset-label": "Pokusy",
          "drop-offs-title": "Kde pokusy končí",
          "drop-offs-description": "Poslední akce, kterou každý pokus provedl. Pokusy končící dokončeným předáním – nyní zaznamenávaným přes banner – byly úspěšné.",
          "no-drop-offs": "V tomto rozsahu nejsou žádné pokusy o konverzi",
          "dwell-title": "Čas před odchodem",
          "dwell-description": "Zaznamenává se pouze v případě, že obchodník opustí krok, plus čas strávený čtením revize před potvrzením.",
          "no-dwell": "V tomto rozsahu nejsou žádná časová data",
          "step": "Krok",
          "samples": "Vzorky",
          "median": "Medián",
          "p90": "P90",
          "top-stores": "Nejlepší obchody",
          "no-top-stores": "Zatím žádná data o obchodech",
          "graph-label": "Zahájené konverze",
          "started-at": "Zahájeno v",
          "duration": "Doba trvání",
          "last-step": "Poslední krok",
          "outcome": "Výsledek",
          "steps": {
            "entry": "Dialog otevřen",
            "category": "Kategorie",
            "mapping": "Mapování",
            "summary": "Revize",
            "convert": "Převést",
            "handover": "Předání",
            "banner": "Banner"
          },
          "actions": {
            "viewed": "zobrazeno",
            "completed": "dokončeno",
            "skipped": "přeskočeno",
            "back": "vrátil se zpět",
            "abandoned": "opuštěno",
            "failed": "selhalo",
            "customize_clicked": "kliknuto na přizpůsobit",
            "dismissed": "zamítnuto"
          },
          "outcomes": {
            "handed-over": "Předáno",
            "converted": "Pouze převedeno",
            "failed": "Selhalo",
            "abandoned": "Opuštěno",
            "in-progress": "Probíhá"
          }
        }
      },
      "delete-category": "Odstranit kategorii",
      "do-you-want-to-delete-selected-categories": "Chcete odstranit vybrané kategorie?",
      "global-categories-are-shared-by-every-store": "Globální kategorie jsou sdíleny všemi obchody — odstranění jedné ovlivní všechny. Tuto akci nelze vrátit zpět.",
      "successfully-deleted-category": "Kategorie byla úspěšně odstraněna",
      "average-cost-per-recommendation": "Průměrné náklady na doporučení",
      "failed-to-load-recommendations-average-cost": "Nepodařilo se načíst průměrné náklady na doporučení",
      "most-expensive-extract": "Nejnákladnější extrakce",
      "most-expensive-recommendation": "Nejnákladnější doporučení",
      "total-recommendation-cost": "Celkové náklady na doporučení",
      "total-size-recommendation": "Doporučení velikosti",
      "total-sheet-extract": "Extrakce z tabulky",
      "new-category": "Nová kategorie",
      "category-created-unlisted-hint": "Kategorie je vytvořena jako neveřejná. Před zveřejněním v obchodech přidejte obrázek a míry.",
      "category-created-successfully": "Kategorie byla úspěšně vytvořena!",
      "category-search-placeholder": "Název obrázku, název obchodu...",
      "dimension-search-placeholder": "Název rozměru, název obchodu...",
      "category-not-found": "Kategorie nebyla nalezena",
      "sub-categories-variants": "Podkategorie/varianty:",
      "add-sub-category-variant": "Přidat podkategorii/variantu:",
      "from-existing": "Z existující",
      "create-a-new": "Vytvořit novou",
      "sub-category-removed": "Podkategorie byla odstraněna!",
      "remove-sub-category": "Odstranit podkategorii",
      "remove-sub-category-confirm": "Odstranit {{ x }} z této kategorie? Zůstane dostupná jako kategorie nejvyšší úrovně.",
      "update-category": "Aktualizovat kategorii",
      "published-category-hint": "Zveřejněná kategorie je viditelná pro všechny obchody. Neveřejné kategorie zůstávají skryté.",
      "category-updated-successfully": "Kategorie byla úspěšně aktualizována!",
      "uninstalled": "Odinstalováno",
      "inactive": "Neaktivní",
      "install-at": "Nainstalováno v",
      "total-chart-views": "Zobrazení tabulky",
      "chart-view-at": "Zobrazení tabulky v",
      "store-id": "ID obchodu",
      "successfully-deleted-clients": "Klienti byli úspěšně odstraněni!",
      "session-replay": "Přehrání relace",
      "watch-on-amplitude": "Zhlédnout na Amplitude",
      "shopify-app": "Aplikace Shopify",
      "shops-online-store": "Online obchod prodejny",
      "no-more-events-to-load": "Žádné další události k načtení!",
      "failed-to-fetch-events": "Nepodařilo se načíst události!",
      "info": "Informace",
      "store-info": "Informace o obchodě",
      "days-ago": "před {{ x }} dny",
      "contact-email": "Kontaktní e-mail",
      "store-url": "URL obchodu",
      "activities": "Aktivity",
      "insights": "Přehledy",
      "subscriptions": "Odběry",
      "failed-to-fetch-client-info": "Nepodařilo se načíst informace o klientovi!",
      "failed-to-load-add-to-cart-analytics": "Nepodařilo se načíst analytiku přidání do košíku",
      "failed-to-load-buy-now-analytics": "Nepodařilo se načíst analytiku koupě nyní",
      "failed-to-load-chart-views": "Nepodařilo se načíst zobrazení tabulky",
      "failed-to-load-size-recommendations-analytics": "Nepodařilo se načíst analytiku doporučení velikosti",
      "failed-to-load-stock-notifications-analytics": "Nepodařilo se načíst analytiku oznámení o skladu",
      "failed-to-load-stock-notifications-table": "Nepodařilo se načíst tabulku oznámení o skladu",
      "chart-views": "Zobrazení tabulky",
      "add-to-cart": "Přidat do košíku",
      "buy-now": "Koupit nyní",
      "size-recommendations": "Doporučení velikosti",
      "stock-notifications": "Oznámení o skladu",
      "change-details": "Změnit podrobnosti",
      "plan-subscription-details": "Podrobnosti předplatného plánu",
      "ai-size-recommendation-limit": "Limit AI doporučení velikosti",
      "ai-size-recommendation-limit-required": "Limit AI doporučení velikosti je povinný!",
      "minimum-limit-is-0": "Minimální limit je 0!",
      "unlimited": "Neomezeno",
      "chart-limit-drafts-hint": "Počítají se jen zveřejněné tabulky. Koncepty jsou neomezené.",
      "chart-limit-required": "Limit tabulek je povinný!",
      "chart-limit-whole-number": "Limit musí být celé číslo!",
      "stock-notification-limit": "Limit oznámení o skladu",
      "stock-notification-limit-required": "Limit oznámení o skladu je povinný!",
      "published-size-chart-limit": "Limit zveřejněných tabulek velikostí",
      "published-table-chart-limit": "Limit zveřejněných tabulek mřížky",
      "analytic": "Analytika",
      "full-suite": "Kompletní sada",
      "select-a-subscription-plan": "Vyberte plán předplatného",
      "failed-to-fetch-plans": "Nepodařilo se načíst plány!",
      "new-plan": "Nový plán",
      "failed-to-assign-plan-subscription-to-client": "Nepodařilo se přiřadit předplatné plánu klientovi!",
      "ai-size-recommendation": "AI doporučení velikosti",
      "stock-notification": "Oznámení o skladu",
      "published-size-charts": "Zveřejněné tabulky velikostí",
      "published-table-charts": "Zveřejněné tabulky mřížky",
      "analytic-access": "Přístup k analytice",
      "activated-at": "Aktivováno v",
      "usages": "Použití",
      "failed-to-fetch-client-plan-subscription": "Nepodařilo se načíst předplatné plánu klienta!",
      "advanced-variant-mapping": "Pokročilé mapování variant",
      "advanced-variant-mapping-description": "Tabulky používají na každém přiřazeném produktu své vlastní velikosti a Přidat do košíku vybere odpovídající variantu produktu. Když je vypnuto, velikosti tabulky musí přesně odpovídat názvům variant každého produktu.",
      "advanced-variant-mapping-counts": "{{ total }} tabulek · {{ x }} s pokročilým mapováním variant",
      "advanced-variant-mapping-drift": "{{ x }} tabulek neodpovídá tomuto nastavení.",
      "advanced-variant-mapping-repair": "Opravit",
      "turn-on-advanced-variant-mapping": "Zapnout pokročilé mapování variant?",
      "turn-off-advanced-variant-mapping": "Vypnout pokročilé mapování variant?",
      "advanced-variant-mapping-on-body": "Všech {{ x }} tabulek tohoto klienta se okamžitě přepne a nové tabulky ho budou používat také. Míry se nemění a můžete ho znovu vypnout.",
      "advanced-variant-mapping-off-body": "Všech {{ x }} tabulek tohoto klienta se vrátí k přesné shodě názvů variant. Tabulky, jejichž velikosti byly přejmenovány, když bylo zapnuto (např. „Blue / S“ na „S“), zobrazí prázdné míry u produktů, jejichž názvy variant už neodpovídají.",
      "turn-on": "Zapnout",
      "turn-off": "Vypnout",
      "failed-to-fetch-advanced-variant-mapping": "Nepodařilo se načíst pokročilé mapování variant!",
      "failed-to-update-advanced-variant-mapping": "Nepodařilo se aktualizovat pokročilé mapování variant!",
      "plan-used-as-free-trial": "Plán použitý jako bezplatná zkušební verze pro nově registrované klienty",
      "x-usages": "{{ x }} použití",
      "successfully-updated-configuration-value": "Hodnota konfigurace byla úspěšně aktualizována",
      "only-authorized-personnel-hint": "Přístup ke globální konfiguraci aplikace a její úpravy má povoleny pouze autorizovaný personál!",
      "password-is-required": "Heslo je povinné",
      "authorize": "Autorizovat",
      "1-month": "1 měsíc",
      "3-months": "3 měsíce",
      "6-months": "6 měsíců",
      "1-year": "1 rok",
      "failed-to-load-costs": "Nepodařilo se načíst náklady",
      "failed-to-load-total-recommendations": "Nepodařilo se načíst celkový počet doporučení",
      "archived": "Archivováno",
      "billing-interval": "Fakturační interval",
      "plan-information": "Informace o plánu",
      "name-is-required": "Název je povinný!",
      "features": "Funkce",
      "stock-notification-recommendation-limit": "Limit doporučení oznámení o skladu",
      "popular": "Oblíbené",
      "allow-trial": "Povolit zkušební verzi",
      "interval": "Interval",
      "interval-is-required": "Interval je povinný!",
      "price-is-required": "Cena je povinná!",
      "minimum-price-is-0": "Minimální cena je 0!",
      "discounted-from": "Sleva z",
      "description": "Popis",
      "description-is-required": "Popis je povinný!",
      "selling-points": "Prodejní argumenty",
      "selling-point-x": "Prodejní argument {{ x }}",
      "selling-point-is-required": "Prodejní argument je povinný!",
      "analytic-is-required": "Analytika je povinná!",
      "support": "Podpora",
      "support-is-required": "Podpora je povinná!",
      "status-is-required": "Stav je povinný!",
      "manage-preset-dimensions": "Spravujte přednastavené rozměry, jejich detekční synonyma a překlady.",
      "detection-synonyms": "Detekční synonyma",
      "add-synonym-placeholder": "Napište synonymum a stiskněte Enter",
      "translations": "Překlady",
      "missing-translation": "Chybějící překlad",
      "new-dimension": "Nový rozměr",
      "edit-dimension": "Upravit rozměr",
      "delete-preset-dimension": "Odstranit přednastavený rozměr",
      "do-you-want-to-delete-this-preset-dimension": "Chcete odstranit \"{{ name }}\"?",
      "preset-dimensions-are-shared-by-every-store": "Přednastavené rozměry jsou sdíleny všemi obchody — odstranění jednoho jej odstraní ze všech kategorií, které jej používají. Tuto akci nelze vrátit zpět.",
      "successfully-created-dimension": "Rozměr byl úspěšně vytvořen!",
      "successfully-updated-dimension": "Rozměr byl úspěšně aktualizován!",
      "successfully-deleted-dimension": "Rozměr byl úspěšně odstraněn!",
      "ai-provider-for-file-imports": "Poskytovatel AI pro import souborů",
      "no-api-key-configured-in-this-environment": "V tomto prostředí není nastaven žádný klíč API",
      "ai-provider-saved-applies-to-new-imports": "Poskytovatel AI byl uložen. Platí pro nové importy; probíhající importy si ponechají svého poskytovatele.",
      "ai-provider-for-size-recommendations": "Poskytovatel AI pro doporučení velikosti",
      "ai-provider-saved-applies-to-next-recommendation": "Poskytovatel AI byl uložen. Platí od příštího doporučení velikosti.",
      "size-recommendation-provider-hint": "Používá se pro AI doporučení velikosti pro zákazníky. Nezávisle na importu souborů.",
      "ai-measurement-import": "Import rozměrů pomocí AI",
      "name-admin-only": "Název (jen pro administrátory)",
      "name-admin-only-hint": "Aplikace podle tohoto názvu rozpoznává tarify Free a Enterprise, proto je nepřejmenovávejte.",
      "display-name": "Zobrazovaný název",
      "display-name-hint": "Zobrazuje se obchodníkům na stránce tarifů, ve fakturaci a v platbě Shopify. Ponechte prázdné pro použití názvu.",
      "display-name-too-long": "Zobrazovaný název může mít nejvýše 40 znaků!",
      "availability": "Dostupnost",
      "available-from-utc": "Dostupné od (UTC)",
      "available-from-hint": "Ponechte prázdné, aby byl nabízen hned, jak bude aktivní.",
      "expires-at-utc": "Vyprší (UTC)",
      "expires-at-required": "Nastavte, kdy vyprší!",
      "window-order": "Musí být dostupný dříve, než vyprší!",
      "your-time": "Váš čas: {{time}}",
      "availability-always": "Nabízen vždy",
      "availability-scheduled": "Naplánováno: zatím se nenabízí",
      "availability-live": "Aktivní: nyní se nabízí",
      "availability-ended": "Skončeno: už se nenabízí",
      "promo-plan": "Akční tarif",
      "replaces-plan": "Nahrazuje",
      "replaces-plan-none": "Nic (běžný tarif)",
      "replaces-plan-hint": "Dokud se tento tarif nabízí, obchodníci ho vidí místo tarifu, který nahrazuje.",
      "campaign": "Kampaň",
      "campaign-required": "Vyberte kampaň, do které tento akční tarif patří!",
      "merchants-see": "Obchodníci vidí",
      "replaces-x": "nahrazuje {{x}}",
      "archiving-hint": "Archivace skryje tarif jen novým předplatitelům. Stávající předplatitelé si ho ponechají.",
      "duplicate-as-promo-plan": "Duplikovat jako akční tarif",
      "help-articles": {
        "topic": "Téma",
        "all-topics": "Všechna témata",
        "topics": {
          "getting-started": "Začínáme",
          "size-charts": "Tabulky velikostí",
          "table-charts": "Tabulky mřížky",
          "assigning-products": "Přiřazení k produktům",
          "storefront-display": "Zobrazení v obchodě",
          "chart-import": "Import tabulek",
          "size-recommendations": "Doporučení velikosti",
          "plans-billing": "Plány a fakturace",
          "troubleshooting": "Řešení problémů"
        },
        "new-article": "Nový článek nápovědy",
        "slug": "Slug",
        "slug-hint": "Adresa článku v centru nápovědy: /help/vas-slug. Změna rozbije odkazy na starou adresu.",
        "slug-invalid": "Použijte malá písmena, číslice a jednoduché pomlčky.",
        "slug-taken": "Tento slug už používá jiný článek.",
        "title-is-required": "Název je povinný",
        "summary": "Shrnutí",
        "summary-hint": "Jeden řádek. Asistent podpory vybírá články podle shrnutí.",
        "summary-is-required": "Shrnutí je povinné",
        "order": "Pořadí",
        "body-hint": "Markdown. Na jiný článek odkažte pomocí [text](/help/jeho-slug).",
        "insert-image": "Vložit obrázek",
        "image-upload-failed": "Obrázek se nepodařilo nahrát.",
        "view-on-help-centre": "Zobrazit v centru nápovědy",
        "broken-links": "Publikováno, ale tyto odkazy vedou na články, které neexistují nebo nejsou publikované:",
        "article-saved": "Článek uložen",
        "article-published": "Článek publikován",
        "article-unpublished": "Publikování článku zrušeno",
        "article-deleted": "Článek smazán",
        "delete-article": "Smazat článek",
        "delete-article-prompt": "Smazat „{{title}}“? Okamžitě zmizí z centra nápovědy i z asistenta podpory.",
        "load-failed": "Článek se nepodařilo načíst.",
        "export": "Exportovat",
        "import": "Importovat",
        "export-failed": "Články se nepodařilo exportovat.",
        "import-title": "Import článků nápovědy",
        "import-checking": "Kontrola souboru…",
        "import-preview": "{{file}} vytvoří {{created}} a aktualizuje {{updated}} článků, s {{images}} obrázky. Články, které v souboru nejsou, zůstanou beze změny.",
        "import-invalid": "Tento soubor nelze importovat:",
        "imported": "Importováno: {{created}} vytvořeno, {{updated}} aktualizováno."
      },
      "invite-only": "Pouze na pozvánku",
      "invite-only-hint": "Skryto na stránce tarifů. Předplatit si ho může kdokoli s odkazem. Po vytvoření tarifu to nelze změnit.",
      "invite-only-price-required": "Tarif pouze na pozvánku musí mít cenu vyšší než 0",
      "copy-invite-link": "Kopírovat odkaz na pozvánku",
      "invite-link-copied": "Odkaz na pozvánku zkopírován",
      "invite-link-copy-failed": "Odkaz na pozvánku se nepodařilo zkopírovat"
    }
  },
  "search": {
    "no-result-found": "Nebyly nalezeny žádné výsledky!",
    "type": {
      "product": "Produkt",
      "variant": "Varianta",
      "client": "Klient"
    },
    "show-less": "Zobrazit méně",
    "show-full": "Zobrazit vše",
    "search-x-by-full-name": "Hledat {{ x }} podle celého jména",
    "load-more...": "Načíst více..."
  },
  "privacy-policy": "Zásady ochrany osobních údajů",
  "contact-us": "Kontaktujte nás",
  "notification": {
    "notification": "Oznámení",
    "mark-all-as-read": "Označit vše jako přečtené",
    "compose": "Vytvořit oznámení",
    "title-required": "Název je povinný!",
    "message-required": "Zpráva je povinná!",
    "sent-to-all-clients": "Oznámení bylo odesláno všem klientům"
  },
  "table": {
    "sort": "Seřadit",
    "sort-by": "Seřadit podle",
    "oldest-first": "Nejstarší první",
    "newest-first": "Nejnovější první",
    "a-z": "A až Z",
    "z-a": "Z až A",
    "lowest-first": "Od nejnižšího",
    "highest-first": "Od nejvyššího",
    "no-data-found": "Nebyla nalezena žádná data"
  },
  "grading": {
    "grading-configuration": "Konfigurace stupňování",
    "base-size": "Základní velikost",
    "enter-your-grading-allowances": "Zadejte své tolerance stupňování",
    "base": "Základ"
  },
  "chart": {
    "image-nav-previous": "Předchozí obrázek",
    "image-nav-next": "Další obrázek",
    "image-nav-position": "{{current}} / {{total}}",
    "image-add-slot-placeholder": "Přidat další obrázek",
    "image-add-slot-formats": "Podporuje .png, .jpeg, .jpg",
    "image-cap-reached": "Dosáhli jste maximálního počtu obrázků pro tuto kategorii.",
    "image-upload-failed": "Obrázek se nepodařilo nahrát. Zkuste to prosím znovu.",
    "image-svg-not-accepted": "Soubory SVG zde nejsou podporovány.",
    "image-delete": "Smazat obrázek",
    "image-move-left": "Posunout obrázek doleva",
    "image-move-right": "Posunout obrázek doprava",
    "image-delete-confirm-title": "Smazat tento obrázek?",
    "image-delete-confirm-body": "Tento obrázek bude trvale odstraněn a nepůjde obnovit.",
    "image-delete-confirm-cancel": "Zrušit",
    "image-delete-confirm-action": "Smazat obrázek",
    "image-delete-last-tooltip": "Kategorie musí mít alespoň jeden obrázek.",
    "image-customize-first-tooltip": "Nejprve tuto kategorii přizpůsobte, abyste mohli spravovat její obrázky.",
    "image-delete-failed": "Obrázek se nepodařilo smazat. Zkuste to prosím znovu.",
    "image-reorder-failed": "Obrázky se nepodařilo přeuspořádat. Zkuste to prosím znovu.",
    "do-you-want-to-delete-this-chart": "Chcete odstranit tuto tabulku?",
    "unnamed-chart": "Nepojmenovaná tabulka",
    "get-size-chart-permalink": "Získat trvalý odkaz na tabulku velikostí",
    "chart-external-link-is-copied-to-clipboard": "Externí odkaz tabulky byl zkopírován do schránky",
    "failed-to-duplicate-chart": "Duplikace tabulky se nezdařila",
    "failed-to-create-chart": "Vytvoření tabulky se nezdařilo",
    "add-new-layout-blocks": "Přidat nové bloky rozvržení",
    "click-on-these-layout-types-and-add-to-the-size-chart": "Klikněte na tyto typy rozvržení a přidejte je do tabulky velikostí",
    "rename-chart": "Přejmenovat tabulku",
    "chart-renamed-successfully": "Tabulka byla úspěšně přejmenována",
    "failed-to-rename-chart": "Přejmenování tabulky se nezdařilo",
    "preview": "Náhled",
    "model-info": "Informace o modelu",
    "model-details": "Podrobnosti o modelu",
    "help-shoppers-by-showing-the-model-height-and-size": "Pomozte zákazníkům zobrazením výšky a velikosti modelu",
    "model-name": "Jméno modelu",
    "enter-model-name": "Zadejte jméno modelu",
    "model-height": "Výška modelu",
    "please-enter-valid-number": "Zadejte platné číslo",
    "size-worn": "Nošená velikost",
    "show-variants-by": "Zobrazit varianty podle",
    "add-options-like-size-or-color": "Přidejte možnosti jako velikost nebo barva",
    "select-existing-chart": "Vybrat existující tabulku",
    "search-charts": "Hledat tabulky podle názvu",
    "no-charts-found": "Nebyly nalezeny žádné tabulky",
    "search-dimensions": "Hledat rozměry",
    "no-dimensions-found": "Nebyly nalezeny žádné rozměry",
    "add-a-new-size-chart": "Přidat novou tabulku velikostí",
    "this-product-is-using-table-chart": "Tento produkt používá tabulku mřížky",
    "update-your-size-chart": "Aktualizujte svou tabulku velikostí",
    "create-your-size-chart": "Vytvořte svou tabulku velikostí",
    "use-a-template": "Použít šablonu",
    "use-template-variants": "Použít šablonu a varianty",
    "pick-a-method-to-get-started": "Vyberte metodu pro začátek",
    "select-an-existing-chart": "Vybrat existující tabulku",
    "image-set-annotation-panel": "Panel anotace sady obrázků",
    "measure-guide": "Průvodce měřením...",
    "drag-drop-to-mark-measurement-bubble": "Přetažením označte bublinu měření",
    "are-you-sure-you-want-to-delete-all-measurements": "Opravdu chcete odstranit všechny míry?",
    "accepts-png-jpeg-jpg-svg": "Přijímá .png, .jpeg, .jpg, .svg",
    "this-name-will-appear-in": "Tento název se zobrazí v",
    "image-set": "sadě obrázků",
    "added-measurements": "Přidané míry",
    "no-measurements-added-yet": "Zatím nebyly přidány žádné míry",
    "drag-and-drop-a-chip-to-edit-its-line-on-the-canvas": "Přetáhněte štítek a upravte jeho čáru na plátně",
    "after-adding-a-measurement-drag-and-drop-it-from-the-section-above-onto-the-image": "Po přidání míry ji přetáhněte ze sekce „Přidané míry“ výše na obrázek",
    "across-shoulder-front-rise-belt": "Šířka ramen, přední sedlo, opasek, ...",
    "create-measurement": "Vytvořit míru",
    "examples-across-shoulder-front-rise-cuff-width": "Příklady: „Šířka ramen“, „Přední sedlo“, „Šířka manžety“",
    "delete-anotation-set": "Odstranit sadu anotací",
    "this-will-remove-all-measurements-from-this-image": "Tímto se odstraní všechny míry z tohoto obrázku",
    "measurement-name": "Název míry",
    "size-recommender": "Doporučovač velikosti",
    "size-recommender-history": "Nedávná doporučení",
    "your-buyer-personal-fitting-assistant-that-instantly-suggests-the-perfect-size-every-time": "Osobní asistent pro velikost vašeho zákazníka, který okamžitě navrhne dokonalou velikost, pokaždé",
    "stretch-factor": "Faktor pružnosti",
    "how-stretchy-is-the-fabric-a-rough-estimate-is-enough-if-unsure-then-leave-at-10": "Jak pružná je látka? Stačí přibližný odhad. Pokud si nejste jisti, ponechte na 10 %",
    "easing": "Volnost střihu",
    "wearing-ease-is-the-amount-added-to-a-person-body-measurements-so-one-can-move-in-a-garment": "Volnost střihu je hodnota přidaná k tělesným mírám osoby, aby se v oděvu dalo pohodlně pohybovat.",
    "set-default": "Nastavit jako výchozí",
    "suggested": "Doporučeno",
    "assign-chart": "Přiřadit tabulku",
    "your-chart-has-not-been-assigned-to-any-product-yet": "Vaše tabulka zatím nebyla přiřazena žádnému produktu",
    "assign-your-chart-so-it-will-appear-on-product-pages": "Přiřaďte svou tabulku, aby se zobrazila na stránkách produktů",
    "assign-it-to-a-product": "Přiřadit ji k produktu",
    "select-the-products-or-collections-where-you-want-your-size-chart-to-appear": "Vyberte produkty nebo kolekce, kde se má vaše tabulka velikostí zobrazit",
    "x-matched-y": "{{ x }} odpovídá {{ y }}",
    "overwritting-x-products": "(přepisuje {{ x }} produktů)",
    "calculating...": "Počítání...",
    "select-product-or-collection": "Vybrat produkt nebo kolekci",
    "remove-all": "Odstranit vše",
    "are-you-sure-you-want-to-remove-all-conditions": "Opravdu chcete odstranit všechny podmínky?",
    "list-of-matched-products": "Seznam odpovídajících produktů",
    "give-your-size-chart-a-name": "Dejte své tabulce velikostí název",
    "this-name-is-only-used-internally-to-help-you-organise-your-charts-customers-wont-see-it": "Tento název se používá pouze interně, aby vám pomohl uspořádat vaše tabulky. Zákazníci ho neuvidí.",
    "eg-mens-t-shirt-size-chart": "např. Tabulka velikostí pánských triček",
    "add-text-block": "Přidat textový blok",
    "product-image-optional": "Obrázek produktu (volitelné)",
    "add-layout-block": "Přidat blok rozvržení",
    "move-this-block-up": "Přesunout tento blok nahoru",
    "move-this-block-down": "Přesunout tento blok dolů",
    "clear-this-image": "Vymazat tento obrázek",
    "align-this-image": "Zarovnat tento obrázek",
    "clear-this-video": "Vymazat toto video",
    "apply-grading-to-this-table": "Použít stupňování na tuto tabulku",
    "duplicate-this-block-to-below": "Duplikovat tento blok níže",
    "remove-this-block": "Odstranit tento blok",
    "upload-an-image": "Nahrát obrázek",
    "browse-to-upload": "Procházet a nahrát",
    "choose-from-our": "Vyberte si z našich",
    "ready-made-templates": "hotových šablon",
    "select-a-template": "Vybrat šablonu",
    "new-row": "Nový řádek",
    "new-column": "Nový sloupec",
    "add-column-left": "Přidat sloupec vlevo",
    "add-column-right": "Přidat sloupec vpravo",
    "move-left": "Přesunout vlevo",
    "move-right": "Přesunout vpravo",
    "freeze": "Ukotvit",
    "unfreeze": "Zrušit ukotvení",
    "delete-column": "Odstranit sloupec",
    "add-row-above": "Přidat řádek nad",
    "add-row-below": "Přidat řádek pod",
    "move-up": "Přesunout nahoru",
    "move-down": "Přesunout dolů",
    "delete-row": "Odstranit řádek",
    "insert-video": "Vložit video",
    "select-a-video": "Vybrat video",
    "paste-a-link-to-a-video-here": "Vložte sem odkaz na video",
    "webgl-not-supported": "Váš prohlížeč nepodporuje WebGL. Zapněte prosím podporu WebGL, pokud používáte moderní prohlížeč jako Chrome, Firefox nebo Safari.",
    "table-chart-created": "Tabulka mřížky byla vytvořena",
    "name-this-image-set": "Pojmenujte tuto sadu obrázků",
    "name-your-import": "Pojmenujte svůj import",
    "table-chart-updated": "Tabulka mřížky byla aktualizována",
    "chart-updated": "Tabulka byla aktualizována",
    "use-how-to-measure-block": "Použít blok „Jak měřit“? (Volitelné)",
    "a-text-block-under-an-expandable-panel-will-be-added-where-you-can-fill-in-details-for-your-customers-on-how-to-measure-their-measurements": "Bude přidán textový blok pod rozbalitelným panelem, kam můžete vyplnit podrobnosti pro zákazníky, jak si míry vzít",
    "newest-5-recommendations-given-to-your-customers": "5 nejnovějších doporučení daných vašim zákazníkům",
    "size-recommended": "Doporučená velikost",
    "view-all-data": "Zobrazit všechna data",
    "please-select-a-size-worn": "Vyberte prosím nošenou velikost",
    "recommended-for-this-garment-add-or-remove-as-needed": "Doporučeno pro tento oděv, přidejte nebo odeberte dle potřeby",
    "add-more": "Přidat další",
    "add-custom-measurements": "Přidat vlastní míry",
    "skip-this-step-next-time": "Příště tento krok přeskočit",
    "use-unit-conversion": "Použít převod jednotek",
    "disabled-by-chart": "Zakázáno tabulkou",
    "disabled-globally-by-settings": "Globálně zakázáno nastavením",
    "hide-unit-conversion-toggle-on-all-charts-appear-on-your-storefront": "Skrýt přepínač převodu jednotek na všech tabulkách zobrazených ve vašem obchodě",
    "assign-products": "Přiřadit produkty",
    "select-products-to-assign-to-the-chart": "Vyberte produkty k přiřazení k tabulce",
    "products-assigned-successfully": "Produkty byly úspěšně přiřazeny",
    "source-table": "Zdrojová tabulka",
    "root-table": "Hlavní tabulka",
    "table-block": "Tabulka",
    "which-axis-holds-the-dimension-data": "Která osa obsahuje data rozměru? (Rameno, pas, atd.)",
    "columns": "Sloupce",
    "rows": "Řádky",
    "measurement-unit": "Měrná jednotka",
    "map-each-line-to-a-dimension": "Namapujte každý řádek na rozměr",
    "ignore": "Ignorovat",
    "line": "Řádek",
    "the-selected-table-has-no-data-to-map": "Vybraná tabulka nemá žádná data k mapování.",
    "tell-us-how-your-table-maps-to-body-dimensions-so-we-can-suggest-a-size": "Řekněte nám, jak se vaše tabulka mapuje na tělesné rozměry, abychom mohli doporučit velikost.",
    "choose-which-table-the-ai-reads-to-suggest-a-size": "Vyberte, kterou tabulku AI čte pro doporučení velikosti.",
    "per-dimension-stretch-and-easing-controls": "Ovládací prvky pružnosti a volnosti pro jednotlivé rozměry",
    "jump-to-table": "Přejít na tabulku",
    "scroll-to-the-selected-table": "Posunout na vybranou tabulku",
    "this-table-is-used-as-your-size-recommendation-data-source": "Tato tabulka se používá jako zdroj dat pro vaše doporučení velikosti",
    "this-table-block-can-not-be-deleted-right-now": "Tento blok tabulky nyní nelze odstranit"
  },
  "error": {
    "there-was-an-error-while-authenticating-your-store": "Při ověřování vašeho obchodu došlo k chybě!",
    "click-the-button-below-to-try-again-if-the-issue-persisted-contact-us-for-further-instruction": "Klikněte na tlačítko níže a zkuste to znovu. Pokud problém přetrvává, kontaktujte nás pro další instrukce.",
    "refresh-the-app": "Obnovit aplikaci",
    "error-occured": "Došlo k chybě!"
  },
  "banner": {
    "add-the-goodchart-size-guide-button-to-your-storefront": "Přidejte tlačítko průvodce velikostí Goodchart do vašeho obchodu",
    "we-ve-detected-you-are-integrating-with-shopify-enable-app-embed-or-add-an-app-block": "Zjistili jsme, že integrujete Shopify. Povolte vložení aplikace pro automatické zobrazení tlačítka průvodce velikostí na každé stránce produktu, nebo přidejte blok aplikace pro jeho umístění na konkrétní místo. Potřebujete pomoc? Podívejte se na tohoto <a class=\"underline\" href=\"{{ guide }}\" target=\"_blank\">průvodce</a>.",
    "enable-app-embed": "Povolit vložení aplikace",
    "add-app-block": "Přidat blok aplikace",
    "your-new-size-chart-is-ready-to-review": "Vaše nová tabulka velikostí je připravena ke kontrole",
    "look-around-then-hand-the-conversion-over": "Pro vaše zákazníky se zatím nic nezměnilo — vaše tabulka mřížky je stále aktivní. Nespěchejte a zkontrolujte míry a průvodce, poté konverzi dokončete, až bude vše v pořádku.",
    "about-your-plan-usage": "O využití vašeho plánu",
    "measurements-applied": "Míry byly použity",
    "selection-applied-all-variants": "Výběr byl použit na všechny varianty velikostí.",
    "you-have-reached-x-of-ai-size-recommendations-limit": "Dosáhli jste {{ x }} % limitu AI doporučení velikosti vašeho aktuálního plánu. Upozorňujeme, že jakékoli využití nad 100 % bude účtováno standardní sazbou.",
    "you-have-reached-x-of-stock-notification-limit": "Dosáhli jste {{ x }} % limitu oznámení o skladu vašeho aktuálního plánu.",
    "over-usage-cost": "Náklady za nadměrné využití",
    "you-have-exceeded-ai-size-recommendation-limit-pay-to-continue-using-service": "Překročili jste limit AI doporučení velikosti. Pokračujte v placení nákladů za nadměrné využití, chcete-li službu dále používat.",
    "you-have-exceeded-ai-size-recommendation-limit-pay-to-continue-using-this-feature": "Překročili jste limit AI doporučení velikosti. Pokračujte v placení nákladů za nadměrné využití, chcete-li tuto funkci dále používat.",
    "n-of-your-table-charts-can-be-upgraded-to-smart-size-charts": "{{count}} vašich tabulek mřížky lze upgradovat na chytré tabulky velikostí"
  },
  "onboarding": {
    "skip-for-now": "Prozatím přeskočit",
    "step-x-of-y": "Krok {{ x }} z {{ y }}",
    "select-the-category-that-best-matches-your-product": "Vyberte kategorii, která nejlépe odpovídá vašemu produktu.",
    "apparel": "Oděvy",
    "tops": "Horní díly",
    "pants": "Kalhoty",
    "dresses": "Šaty",
    "shoes": "Obuv",
    "sneakers": "Tenisky",
    "boots": "Boty",
    "sandals": "Sandály",
    "accessories": "Doplňky",
    "belts": "Opasky",
    "bags": "Tašky",
    "hats": "Klobouky",
    "other-custom": "Jiné/vlastní",
    "equipment": "Vybavení",
    "tool": "Nástroj",
    "furniture": "Nábytek",
    "upload-any-product-image-and-place-measurements-visually-works-for-apparel-shoes-and-accessories": "Nahrajte libovolný obrázek produktu a vizuálně umístěte míry. Funguje pro oděvy, obuv a doplňky.",
    "table-style-chart": "Tabulka ve stylu mřížky",
    "create-a-grid-based-chart-with-rows-and-columns-best-for-detailed-size-specifications": "Vytvořte tabulku založenou na mřížce s řádky a sloupci. Ideální pro podrobné specifikace velikostí.",
    "your-size-chart-is-ready": "Vaše tabulka velikostí je připravena",
    "you-can-now-decide-where-this-size-chart-should-appear-in-your-store-you-can-skip-this-step-and-assign-products-later": "Nyní se můžete rozhodnout, kde se tato tabulka velikostí má ve vašem obchodě zobrazit. Tento krok můžete přeskočit a produkty přiřadit později.",
    "apply-this-chart-to-products-now": "Použít tuto tabulku na produkty nyní",
    "choose-which-products-should-use-this-size-chart": "Vyberte, které produkty mají tuto tabulku velikostí používat.",
    "i-ll-do-this-later": "Udělám to později",
    "you-can-assign-or-change-matching-anytime-from-chart-settings": "Přiřazení nebo shodu můžete kdykoli změnit v nastavení tabulky.",
    "select-products-to-assign-chart-to": "Vyberte produkty, kterým chcete tabulku přiřadit",
    "apply-this-chart-to-all-products": "Použít tuto tabulku na všechny produkty.",
    "select-products-to-apply-this-chart-to": "Vyberte produkty, na které chcete tuto tabulku použít.",
    "assigning...": "Přiřazování...",
    "size-chart-created-successfully": "Tabulka velikostí byla úspěšně vytvořena",
    "you-can-assign-products-anytime-from-chart-settings": "Produkty můžete kdykoli přiřadit v nastavení tabulky.",
    "view-chart": "Zobrazit tabulku",
    "go-to-dashboard": "Přejít na přehled",
    "turn-your-size-chart-into-a-conversion-tool": "Proměňte svou tabulku velikostí v konverzní nástroj",
    "help-shoppers-pick-the-right-size-and-reduce-returns": "Pomozte zákazníkům vybrat správnou velikost a snižte počet vrácení.",
    "setup-takes-about-2-minutes": "Nastavení trvá asi 2 minuty.",
    "choose-how-your-size-chart-looks": "Vyberte, jak bude vaše tabulka velikostí vypadat",
    "other-ways-to-create-a-chart": "Další způsoby, jak vytvořit tabulku",
    "failed-to-proceed-please-try-again": "Nepodařilo se pokračovat, zkuste to prosím znovu",
    "this-chart-connects-to-your-shopify-product-and-variants-so-shoppers-can-select-their-size-add-to-cart-or-buy-now-without-leaving-the-chart": "Tato tabulka se propojuje s vaším produktem a variantami Shopify, takže zákazníci mohou vybrat svou velikost, přidat do košíku nebo koupit nyní, aniž by tabulku opustili",
    "add-the-size-guide-button-to-your-storefront": "Přidejte tlačítko průvodce velikostí do vašeho obchodu",
    "choose-how-the-goodchart-size-guide-button-should-appear-on-your-product-pages": "Vyberte, jak se má tlačítko průvodce velikostí GoodChart zobrazovat na stránkách vašich produktů.",
    "enable-app-embed": "Povolit vložení aplikace",
    "installed": "Nainstalováno",
    "automatically-display-the-size-guide-button-on-all-product-pages": "Automaticky zobrazit tlačítko průvodce velikostí na všech stránkách produktů.",
    "add-app-block-to-product-page": "Přidat blok aplikace na stránku produktu",
    "prefer-to-place-the-button-in-a-specific-spot-on-your-product-page": "Preferujete umístit tlačítko na konkrétní místo na stránce produktu?",
    "place-the-size-guide-button-in-a-specific-spot-on-your-product-page-template": "Umístěte tlačítko průvodce velikostí na konkrétní místo v šabloně stránky produktu.",
    "open": "Otevřít",
    "check-button-installation": "Zkontrolovat instalaci tlačítka",
    "checking": "Kontroluje se...",
    "great-the-size-guide-button-is-installed-on-your-storefront": "Skvělé! Tlačítko průvodce velikostí je nainstalováno ve vašem obchodě.",
    "we-could-not-detect-the-size-guide-button-yet-please-make-sure-you-saved-the-changes-in-the-theme-editor": "Tlačítko průvodce velikostí se nám zatím nepodařilo zjistit. Ujistěte se, že jste uložili změny v editoru motivu.",
    "app-block-installed-on-your-product-page": "Blok aplikace byl nainstalován na stránce vašeho produktu"
  },
  "common": {
    "updated": "Aktualizováno",
    "name": "Název",
    "avatar": "Avatar",
    "category-image": "Obrázek kategorie",
    "increase": "Zvýšit",
    "created": "Vytvořeno",
    "email": "E-mail",
    "password": "Heslo",
    "yes": "Ano",
    "no": "Ne",
    "chart": "Tabulka",
    "gender": "Pohlaví",
    "height": "Výška",
    "weight": "Hmotnost",
    "age-group": "Věková skupina",
    "fit-preference": "Preference střihu",
    "score": "Skóre",
    "table-chart": "Tabulka mřížky",
    "draft": "Koncept",
    "active": "Aktivní",
    "products": "Produkty",
    "none": "Žádné",
    "cancel": "Zrušit",
    "retry": "Zkusit znovu",
    "delete": "Odstranit",
    "export": "Exportovat",
    "variant": "Varianta",
    "variants": "Varianty",
    "account": "Účet",
    "personal": "Osobní",
    "appearance": "Vzhled",
    "organization": "Organizace",
    "information": "Informace",
    "first-name": "Jméno",
    "last-name": "Příjmení",
    "save": "Uložit",
    "pay": "Zaplatit",
    "undo": "Zpět",
    "redo": "Znovu",
    "newsletter-subscription": "Odběr novinek",
    "button": "Tlačítko",
    "colour": "Barva",
    "default": "Výchozí",
    "white": "Bílá",
    "light-grey": "Světle šedá",
    "soft-beige": "Jemná béžová",
    "saving...": "Ukládání...",
    "all-changes-saved": "Všechny změny byly uloženy",
    "publish": "Zveřejnit",
    "unpublish": "Zrušit zveřejnění",
    "images": "Obrázky",
    "charts": "Tabulky",
    "confirm": "Potvrdit",
    "dimensions": "Rozměry",
    "new": "Nové",
    "missing": "Chybí",
    "editing-x": "Úprava {{ x }}",
    "back-in-stock": "Zpět skladem",
    "product": "Produkt",
    "grading": "Stupňování",
    "more-actions": "Další akce",
    "table": "Tabulka",
    "measurement": "Míra",
    "close": "Zavřít",
    "apply": "Použít",
    "duplicate": "Duplikovat",
    "add-layout-blocks": "Přidat bloky rozvržení",
    "text": "Text",
    "image": "Obrázek",
    "video": "Video",
    "new-name": "Nový název",
    "published": "Zveřejněno",
    "all": "Vše",
    "editing": "Úprava",
    "show-more": "Zobrazit více",
    "loading": "Načítání",
    "or": "Nebo",
    "browse-files": "Procházet soubory",
    "edit": "Upravit",
    "customize": "Přizpůsobit",
    "clear": "Vymazat",
    "label": "Popisek",
    "discard-changes": "Zahodit změny",
    "uploading": "Nahrávání...",
    "preset": "Předvolba",
    "custom": "Vlastní",
    "manage": "Spravovat",
    "done": "Hotovo",
    "reminder": "Připomínka",
    "collections": "Kolekce",
    "all-products": "Všechny produkty",
    "select": "Vybrat",
    "search": "Hledat",
    "select-all": "Vybrat vše",
    "size-chart": "Tabulka velikostí",
    "continue": "Pokračovat",
    "back": "Zpět",
    "visual-measurement-builder": "Vizuální tvůrce měření",
    "recommend": "Doporučit",
    "creating...": "Vytváření...",
    "syncing": "Synchronizace...",
    "preview": "Náhled",
    "create": "Vytvořit",
    "onboarding": "Onboarding",
    "english": "English",
    "french": "Français",
    "spanish": "Español",
    "czech": "Čeština",
    "danish": "Dánština",
    "german": "Němčina",
    "italian": "Italština",
    "dutch": "Nizozemština",
    "japanese": "Japonština",
    "off": "Vypnuto",
    "basic": "Základní",
    "AI": "AI",
    "details": "Podrobnosti",
    "date": "Datum",
    "billing": "Fakturace",
    "settings": "Nastavení",
    "log-out": "Odhlásit se",
    "plan": "Plán",
    "ai-size-recommendation": "AI doporučení velikosti",
    "recommendations": "Doporučení",
    "features": "Funkce",
    "stock-notification": "Oznámení o skladu",
    "published-size-charts": "Zveřejněné tabulky velikostí",
    "published-table-charts": "Zveřejněné tabulky mřížky",
    "unlimited": "Neomezeno",
    "x-of-y": "{{ x }} z {{ y }}",
    "measurements": "Míry",
    "selected": "Vybráno",
    "select-product": "Vybrat produkt",
    "price": "Cena",
    "title": "Název",
    "message": "Zpráva",
    "add": "Přidat",
    "remove": "Odstranit",
    "cm": "cm",
    "in": "palce",
    "usd": "USD",
    "return": "Zpět",
    "next": "Další",
    "store": "Obchod",
    "type": "Typ",
    "cost": "Náklady",
    "incurred-at": "Vzniklo v",
    "search-placeholder": "Hledat...",
    "more": "Více...",
    "load-more": "Načíst více...",
    "status": "Stav",
    "enabled": "Povoleno",
    "disabled": "Zakázáno",
    "total": "Celkem",
    "un-listed": "Nezveřejněné",
    "global": "Globální",
    "store-specific": "Specifické pro obchod",
    "ai-measurement-import": "Import rozměrů pomocí AI",
    "included": "Zahrnuto",
    "not-included": "Nezahrnuto"
  },
  "snackbar": {
    "successfully-updated-your-preferences": "Vaše předvolby byly úspěšně aktualizovány",
    "failed-to-update-your-preferences": "Aktualizace vašich předvoleb se nezdařila"
  },
  "import": {
    "upload-file": "Nahrát soubor",
    "sheet-import": {
      "title": "Nahrát míry ze souboru",
      "dropzone": {
        "title": "Přetáhněte soubor sem",
        "accepted-types": "{{types}} – vždy jeden soubor",
        "browse": "Procházet soubory"
      },
      "hint": "Nejlepší výsledky: jedna tabulka, jejíž velikosti odpovídají variantám této tabulky velikostí, se záhlavím v prvním řádku nebo sloupci. Fotografie či snímek obrazovky by měly být ostré, pořízené zepředu a oříznuté jen na tabulku.",
      "example": {
        "caption": "Příklad podporovaného rozvržení:",
        "size": "Velikost",
        "chest": "Hrudník (cm)",
        "waist": "Pas (cm)"
      },
      "error": {
        "invalid-type": "Tento typ souboru není podporován. Nahrajte jeden z těchto: {{types}}.",
        "heic-unsupported": "Fotografie HEIC (formát iPhonu) nejsou podporovány. Exportujte fotografii jako JPG nebo PNG a nahrajte tento soubor.",
        "file-too-large": "Soubor je příliš velký. Maximální velikost je {{maxSizeMb}} MB."
      },
      "submit": "Nahrát a zkontrolovat změny",
      "running": {
        "this-chart": "Pro tuto tabulku velikostí již probíhá import.",
        "other-chart": "Pro jinou tabulku velikostí již probíhá import. Najednou může probíhat pouze jeden import.",
        "open-import": "Zobrazit import"
      },
      "accepted-files-tooltip": "Podporované soubory: {{types}}",
      "button": {
        "importing": "Importuje se… {{progress}} %",
        "review": "Zkontrolovat import"
      }
    }
  },
  "size-recommender": {
    "form": {
      "title": "Najděte svou nejlepší velikost",
      "subtitle": "Několik rychlých údajů pro lepší padnutí",
      "shopping-for": "NAKUPUJI PRO",
      "women": "Ženy",
      "men": "Muže",
      "other": "Jiné",
      "measurements": "MÍRY",
      "height": "Výška",
      "height-required": "Výška je povinná",
      "min-height": "Minimální výška je 1",
      "weight": "Hmotnost",
      "weight-required": "Hmotnost je povinná",
      "min-weight": "Minimální hmotnost je 1",
      "preferred-fit": "Preferovaný střih"
    },
    "result": {
      "suggested-size": "Doporučená velikost:",
      "no-fit": "Bohužel se zdá, že momentálně nemáme ideální velikost. Doporučujeme se vrátit později pro další možnosti.",
      "verdict": "Verdikt:",
      "similar-variants": "Podobné varianty:",
      "proceed": "Pokračovat s touto variantou",
      "estimate-disclaimer": "(Odhad založený na značce a údajích uživatele, výsledky se mohou lišit.)"
    },
    "ai": {
      "upgrade-title": "Upgradujte svůj plán a odemkněte AI doporučení velikosti",
      "upgrade-description": "Funkce, která pomáhá vašim zákazníkům pokaždé najít správnou velikost. Naše AI analyzuje podrobnosti o produktu a údaje zákazníka, aby poskytla personalizovaná doporučení velikosti, takže zákazníci nakupují s důvěrou a vy vidíte méně vrácení a výměn. Upgradujte nyní a nabídněte tento zážitek ve svém obchodě.",
      "image-alt": "Doporučení velikosti",
      "upgrade-enable": "Upgradovat a povolit nyní",
      "explore-plans": "Prozkoumat další plány",
      "failed-load-recommendations": "Nepodařilo se načíst doporučení",
      "failed-fetch-plans": "Nepodařilo se načíst plány",
      "form-tab": "Formulář",
      "result-tab": "Výsledek"
    },
    "basic": {
      "measurements-required-title": "Nejprve přidejte míry",
      "measurements-required-description": "Základní doporučení velikosti přiřazuje kupujícím velikost podle měr v této tabulce. Přidejte do tabulky míry a poté jej zapněte."
    }
  },
  "chart-limit": {
    "title-size": "Dosáhli jste limitu zveřejněných tabulek velikostí",
    "title-table": "Dosáhli jste limitu zveřejněných tabulek mřížky",
    "description-size": "Váš plán umožňuje zveřejnit {{limit}} tabulek velikostí a zveřejněno jich máte {{usage}}. Tato tabulka zůstala jako koncept. Upgradujte plán, abyste mohli zveřejnit další, nebo zrušte zveřejnění tabulky, kterou už nepotřebujete.",
    "description-table": "Váš plán umožňuje zveřejnit {{limit}} tabulek mřížky a zveřejněno jich máte {{usage}}. Tato tabulka zůstala jako koncept. Upgradujte plán, abyste mohli zveřejnit další, nebo zrušte zveřejnění tabulky, kterou už nepotřebujete.",
    "upgrade-plan": "Upgradovat plán",
    "explore-plans": "Prozkoumat plány",
    "failed-fetch-plans": "Plány se nepodařilo načíst. Zkuste to prosím znovu.",
    "image-alt": "Ilustrace tabulky",
    "onboarding-saved-as-draft": "Vaše tabulka byla uložena jako koncept, protože jste dosáhli limitu zveřejněných tabulek ve svém plánu. Zveřejnit ji můžete po upgradu plánu nebo po zrušení zveřejnění jiné tabulky."
  },
  "help-centre": "Centrum nápovědy",
  "dimension-inputs": {
    "add-measurement": "Přidat míru"
  },
  "variant-editor": {
    "option-name": "Název možnosti",
    "option-values": "Hodnoty možnosti",
    "option-placeholder": "Velikost / Barva / Materiál",
    "add-option": "Přidat další možnost"
  },
  "dimension": {
    "shoulder": "Rameno",
    "bust": "Hrudník",
    "waist": "Pas",
    "arm": "Paže",
    "sleeve": "Rukáv",
    "hip": "Boky",
    "crotch": "Rozkrok",
    "leg": "Noha",
    "thigh": "Stehno",
    "length": "Délka",
    "bottom_width": "Šířka spodního lemu",
    "chest": "Hrudník",
    "inside_leg": "Vnitřní délka nohy",
    "back_length": "Délka zad",
    "front_length": "Délka přední",
    "front_rise": "Přední sedlo",
    "back_rise": "Zadní sedlo",
    "leg_opening": "Šířka nohavice",
    "overbust": "Obvod nad hrudníkem",
    "underbust": "Obvod pod hrudníkem",
    "groups": {
      "tops": "Horní díly",
      "bottoms": "Spodní díly",
      "generals": "Obecné"
    }
  },
  "analytic": {
    "range": {
      "1m": "1 měsíc",
      "3m": "3 měsíce",
      "6m": "6 měsíců",
      "1y": "1 rok"
    }
  },
  "store-history": {
    "a-restore-is-already-running-for-this-store": "Pro tento obchod už obnova probíhá. Počkejte, až skončí, a zkuste to znovu.",
    "a-snapshot-is-taken-only-on-days-you-change-something": "Záloha vzniká jen ve dnech, kdy něco změníte.",
    "actor": {
      "merchant": "vy",
      "support": "Podpora Goodchart",
      "system": "Shopify"
    },
    "billing-plan-login-and-connected-integrations-are-not-touched": "Fakturace, tarif, přihlášení ani propojené integrace se nemění.",
    "blocked": {
      "entity-exists": "Už bylo vytvořeno znovu – raději obnovte",
      "entity-missing": "Už neexistuje – raději obnovte",
      "unsupported": "Nelze vrátit zpět – raději obnovte",
      "value-changed": "Od té doby změněno – raději obnovte"
    },
    "changes": "Změny",
    "discard-unsaved-changes": "Zahodit neuložené změny?",
    "dont-ask-again-in-this-session": "V této relaci se už neptat",
    "earlier": "Dříve",
    "history": "Historie",
    "history-starts-from-your-first-snapshot": "Historie začíná vaší první zálohou",
    "label": {
      "category-created": "Kategorie {{name}} vytvořena",
      "category-deleted": "Kategorie {{name}} smazána",
      "category-updated": "Kategorie {{name}} upravena",
      "chart-created": "Tabulka velikostí {{name}} vytvořena",
      "chart-deleted": "Tabulka velikostí {{name}} smazána",
      "chart-updated": "Tabulka velikostí {{name}} upravena",
      "dimension-created": "Míra {{name}} vytvořena",
      "dimension-deleted": "Míra {{name}} smazána",
      "dimension-updated": "Míra {{name}} upravena",
      "draft-assignment-rules": "Pravidla přiřazení změněna",
      "draft-edited": "Tabulka upravena",
      "draft-guide": "Návod k měření upraven",
      "draft-labels": "Označení velikostí upravena",
      "draft-measurements": "Rozměry upraveny",
      "draft-model": "Rozměry modelky změněny",
      "draft-publication": "Publikace změněna",
      "draft-renamed": "Tabulka přejmenována",
      "draft-size-recommender": "Doporučení velikosti změněno",
      "draft-variants": "Varianty upraveny",
      "keyword-created": "Klíčové slovo {{name}} vytvořeno",
      "keyword-deleted": "Klíčové slovo {{name}} smazáno",
      "keyword-updated": "Upraveno {{count}} klíčových slov",
      "products-assigned": "Přiřazeno {{count}} produktů",
      "profile-updated": "Profil obchodu aktualizován",
      "store-restored": "Obchod obnoven k {{date}}",
      "table-chart-created": "Tabulka {{name}} vytvořena",
      "table-chart-deleted": "Tabulka {{name}} smazána",
      "table-chart-updated": "Tabulka {{name}} upravena"
    },
    "no-changes-since-then": "Od té doby žádné změny.",
    "no-snapshots-yet": "Zatím žádné zálohy",
    "nothing-created-since-then-will-be-deleted": "Nic vytvořeného od té doby se nesmaže.",
    "plus-x-more": "+{{x}} dalších",
    "reloading-the-dashboard": "Načítáme přehled znovu…",
    "restore": "Obnovit",
    "restore-confirmation-word": "OBNOVIT",
    "restore-instead": "Raději obnovit",
    "restore-your-store": "Obnovit váš obchod",
    "restoring-your-store-do-not-close-this-window": "Obnovujeme váš obchod. Nezavírejte toto okno.",
    "since-the-x-snapshot": "Od zálohy z {{x}}",
    "snapshots": "Zálohy",
    "the-change-was-undone-but-the-page-could-not-refresh": "Změna byla vrácena zpět, ale stránku se nepodařilo obnovit. Načtěte ji znovu.",
    "this-backup-predates-image-protection": "Tato záloha pochází z doby před ochranou obrázků, takže obrázky smazané od té doby nelze obnovit.",
    "this-changes-what-shoppers-see-on-your-product-pages-within-seconds": "Během několika sekund se změní, co zákazníci vidí na stránkách produktů.",
    "this-changes-what-shoppers-see-right-away": "Okamžitě se tím změní, co vidí zákazníci.",
    "this-puts-your-store-back-to-how-it-was-on-x": "Vrátí to váš obchod do stavu z {{x}}.",
    "this-reverses-x-actions-up-to-and-including-y": "Tím se vrátí zpět {{x}} akcí, včetně „{{y}}“.",
    "trigger": {
      "daily": "Denní",
      "install": "Při instalaci Goodchartu",
      "manual": "Ruční (podpora)",
      "migration": "První záloha",
      "pre-restore": "Před obnovou",
      "reinstall": "Při přeinstalaci Goodchartu"
    },
    "type-x-to-confirm": "Pro potvrzení napište {{x}}",
    "undid-x": "Vráceno zpět: „{{x}}“",
    "undo-a-saved-change": "Vrátit zpět uloženou změnu",
    "undo-to-here": "Vrátit zpět až sem",
    "undo-x-saved-y": "Vrátit zpět „{{x}}“, uloženo {{y}}?",
    "unsaved": "Neuloženo",
    "we-could-not-load-your-history": "Historii se nepodařilo načíst.",
    "we-could-not-load-your-snapshots": "Zálohy se nepodařilo načíst.",
    "we-could-not-restore-your-store": "Váš obchod se nepodařilo obnovit.",
    "we-could-not-work-out-what-would-change": "Nepodařilo se zjistit, co by se změnilo.",
    "we-take-a-snapshot-of-your-current-store-first-so-this-can-be-undone": "Nejprve zálohujeme váš současný obchod, takže to lze vrátit zpět.",
    "we-take-a-snapshot-of-your-store-each-day-it-changes": "Zálohu obchodu vytváříme každý den, kdy se změní. Historie se tu objeví, jakmile vznikne první záloha.",
    "what-comes-back": "Co se vrátí",
    "what-is-lost": "Co se ztratí",
    "working-out-what-would-change": "Zjišťujeme, co by se změnilo…",
    "x-assignments": "Přiřazení: {{x}}",
    "x-charts": "Tabulky velikostí: {{x}}",
    "x-images-cannot-be-brought-back": "{{x}} obrázků nelze obnovit – byly smazány před více než 37 dny.",
    "x-images-could-not-be-recovered": "{{x}} obrázků se nepodařilo obnovit – byly smazány před více než 37 dny.",
    "x-items-created-since-then-will-be-deleted": "Smaže se {{x}} položek vytvořených od té doby, mimo jiné:",
    "x-items-will-be-recreated": "Obnoví se {{x}} položek.",
    "x-no-longer-exists-after-the-undo": "„{{x}}“ po vrácení zpět už neexistuje.",
    "x-table-charts": "Tabulky: {{x}}",
    "you-have-unsaved-changes-to-x-undoing-will-discard-them": "Máte neuložené změny v „{{x}}“. Vrácením zpět o ně přijdete.",
    "your-store-has-been-restored": "Váš obchod byl obnoven."
  },
  "chart-import": {
    "progress": {
      "stage": {
        "reading-file": "Čtení souboru",
        "understanding-table": "Analýza tabulky",
        "matching-measurements": "Přiřazování měr",
        "building-chart": "Vytváření tabulky velikostí"
      },
      "reconnecting": "Obnovuje se připojení – chvíli strpení, váš postup se neztratil.",
      "keep-working": "Můžete pokračovat v práci — až bude hotovo, dáme vám vědět.",
      "cancel": "Zrušit import",
      "cancel-confirm": {
        "title": "Zrušit tento import?",
        "message": "Nahraný soubor bude zahozen a tento import nebude možné obnovit.",
        "keep": "Počkat",
        "discard": "Zrušit import"
      },
      "ready": {
        "title": "Tabulka velikostí je připravena ke kontrole",
        "action": "Zkontrolovat změny"
      }
    },
    "failure": {
      "unreadable-file": {
        "message": "Fotografie byla příliš rozmazaná nebo tmavá, abychom ji mohli přečíst. Nejlépe funguje ostřejší a dobře osvětlená fotografie."
      },
      "no-table-found": {
        "message": "V tomto souboru jsme nenašli žádnou tabulku velikostí."
      },
      "unsupported-layout": {
        "message": "Rozvržení této tabulky zatím neumíme přečíst."
      },
      "model-timeout": {
        "message": "Trvalo to příliš dlouho – obvykle jde o dočasný problém."
      },
      "internal": {
        "message": "Při importu tabulky velikostí se na naší straně něco pokazilo."
      },
      "action": {
        "retry": "Zkusit znovu",
        "try-another-photo": "Zkusit jinou fotografii",
        "try-another-file": "Zkusit jiný soubor",
        "other-methods": "Jiné metody"
      }
    },
    "diff-review": {
      "title": "Zkontrolujte změny",
      "subtitle": "Zrušte zaškrtnutí u všeho, co na tuto tabulku velikostí nechcete použít.",
      "load-error": "Změny z tohoto importu se nepodařilo načíst.",
      "no-changes": "Žádné míry se nezměnily.",
      "grid": {
        "variant": "Velikost",
        "dimension": "Míra",
        "old-value": "Aktuální",
        "new-value": "Nová"
      },
      "unmatched-variants": "Velikosti v souboru, které neodpovídají této tabulce velikostí:",
      "unmapped-dimensions": "Sloupce, které se nepodařilo přiřadit k žádné míře:",
      "apply": {
        "button": "Použít změny ({{count}})",
        "success": "Tabulka velikostí aktualizována (použité změny: {{count}})",
        "generic-error": "Tyto změny se nepodařilo použít. Zkuste to prosím znovu."
      },
      "cancel": {
        "button": "Zrušit import"
      }
    },
    "review": {
      "cancel-confirm": {
        "title": "Zrušit tento import?",
        "message": "Nahraný soubor i vaše úpravy budou zahozeny. Tento import nebude možné obnovit.",
        "keep": "Pokračovat v kontrole",
        "discard": "Zrušit import"
      }
    },
    "page": {
      "title": "Importovat míry",
      "empty": {
        "title": "Pro tuto tabulku velikostí neprobíhá žádný import",
        "message": "Nahrajte tabulku nebo fotografii tabulky velikostí a aktualizujte míry této tabulky."
      }
    },
    "upgrade": {
      "title": "Importujte rozměry pomocí AI",
      "description": "Nahrajte tabulku nebo fotku tabulky velikostí a my za vás doplníme rozměry této tabulky. Import rozměrů pomocí AI není součástí vašeho současného plánu. Upgradujte plán, abyste ho mohli používat.",
      "upgrade-plan": "Upgradovat plán",
      "explore-plans": "Prozkoumat plány",
      "failed-fetch-plans": "Plány se nepodařilo načíst. Zkuste to prosím znovu.",
      "image-alt": "Ilustrace tabulky velikostí"
    }
  },
  "promotion": {
    "BlackFriday": {
      "name": "Black Friday",
      "chip": "Cena Black Friday",
      "popup": {
        "eyebrow": "Black Friday · Cyber Monday",
        "headline": "Sleva až {{percent}} %",
        "subheadline": "na tarify Goodchart",
        "body": "Připravte si tabulky velikostí na nejrušnější týden roku. Jasné velikosti znamenají méně dotazů „sedne mi to?“ a méně vratek.",
        "feature-recommender": "AI doporučení velikosti, které každému zákazníkovi navrhne jeho velikost",
        "feature-import": "AI import, který ze souboru nebo obrázku vytvoří tabulku velikostí",
        "feature-analytics": "Analytika toho, jak zákazníci používají vaše tabulky velikostí",
        "cta": "Zobrazit nabídky",
        "later": "Možná později"
      },
      "show-offer": "Zobrazit nabídku Black Friday"
    },
    "every-plan": "Sleva {{percent}} % na všechny tarify",
    "up-to": "Sleva až {{percent}} %",
    "switch-to": "Přejít na {{price}} $/{{interval}}",
    "switch-from": "Máte {{name}} za {{price}} $/{{interval}}. Stejné funkce, o {{percent}} % levněji.",
    "switch-note-monthly": "Shopify vás požádá o schválení nové ceny a zbytek tohoto měsíce vám připíše.",
    "switch-note-annual": "Shopify vás požádá o schválení nové ceny, která začne platit při obnovení {{date}}.",
    "switch-note-annual-undated": "Shopify vás požádá o schválení nové ceny, která začne platit při příštím obnovení."
  },
  "agent-chat": {
    "open": "Otevřít chat podpory",
    "close": "Zavřít chat podpory",
    "expand": "Zvětšit chat",
    "collapse": "Zmenšit chat",
    "title": "Podpora Goodchart",
    "history": "Konverzace",
    "back": "Zpět ke konverzaci",
    "new": "Nová konverzace",
    "placeholder": "Zeptejte se na cokoli o Goodchartu",
    "send": "Odeslat",
    "welcome": "Dobrý den! Zeptejte se na cokoli o Goodchartu: nastavení tabulek velikostí, průvodce velikostmi ve vašem obchodě nebo váš tarif.",
    "history-empty": "Zatím žádné konverzace.",
    "unread": "Nová odpověď",
    "you": "Vy",
    "merchant": "Obchodník",
    "assistant": "Asistent Goodchart",
    "team": "Tým Goodchart",
    "typing": "Píše…",
    "used-articles": "Odpověď z článků nápovědy",
    "retry": "Zkusit znovu",
    "activity": {
      "articles": "Čte články nápovědy…",
      "store": "Prohlíží váš obchod…",
      "code": "Ověřuje, jak Goodchart funguje…",
      "team": "Předává dotaz týmu Goodchart…"
    },
    "error": {
      "rate-limited": "Posíláte zprávy příliš rychle. Zkuste to znovu za {{seconds}} s. Pokud potřebujete tým Goodchart, požádejte mě o něj, až budete moci znovu psát.",
      "daily-cap": "Dosáhli jste dnešního limitu zpráv. Zkuste to znovu zítra a pokud budete stále potřebovat tým Goodchart, požádejte mě o něj.",
      "disabled": "Asistent podpory je momentálně nedostupný.",
      "reply-failed": "Odpověď nedorazila.",
      "unknown": "Něco se pokazilo."
    },
    "placeholder-team": "Doplňte podrobnosti pro tým Goodchart",
    "unavailable": "Asistent podpory je momentálně nedostupný, takže nepřijímá nové dotazy. Konverzace, které už řeší tým Goodchart, zůstávají otevřené ve vaší historii.",
    "waiting": {
      "title": "Čeká se na tým Goodchart.",
      "body": "Odpoví zde a dostanete upozornění. Mezitím můžete doplnit podrobnosti."
    },
    "starters": {
      "create-chart": "Jak vytvořím tabulku velikostí?",
      "no-chart": "Které moje produkty nemají tabulku velikostí?",
      "not-showing": "Proč se moje tabulka velikostí nezobrazuje v obchodě?",
      "charts-left": "Kolik dalších tabulek mohu zveřejnit?"
    },
    "feedback": {
      "helpful": "Užitečné",
      "not-helpful": "Neužitečné",
      "thanks": "Děkujeme za zpětnou vazbu.",
      "comment-placeholder": "Co bylo špatně nebo chybělo? (nepovinné)",
      "send": "Odeslat",
      "skip": "Přeskočit",
      "rated-up": "Hodnoceno jako užitečné",
      "rated-down": "Hodnoceno jako neužitečné"
    }
  }
}
